
// import React, { useState, useEffect } from 'react';
// import { useNavigate, useLocation } from 'react-router-dom';
// import {
//   Box,
//   Typography,
//   TextField,
//   Button,
//   Select,
//   MenuItem,
//   FormControl,
//   Dialog,
//   DialogContent,
//   DialogActions,
//   Grid,
//   Card,
//   CardContent,
//   IconButton,
//   FormHelperText,
//   InputAdornment,
//   Container,
//   useTheme,
//   useMediaQuery,
//   List,
//   Paper,
//   ListItem,
//   ListItemText,
//   Popper,
//   Grow,
//   ClickAwayListener,
//   styled,
// } from '@mui/material';
// import CheckCircleIcon from '@mui/icons-material/CheckCircle';
// import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
// import CloseIcon from '@mui/icons-material/Close';
// import CloudUpload from '@mui/icons-material/CloudUpload';
// import { useSelector } from 'react-redux';
// import { selectUser } from '../Commonlibs/userSlice';

// // Import all your icons (keeping all your existing imports)
// import yourIcon from '../assets/greencir.png';
// import apartmentIcon from "../assets/appsell.png";
// import independentHouseIcon from "../assets/apphouse.png";
// import duplexIcon from "../assets/appduple.png";
// import pentHouseIcon from "../assets/apppent.png";
// import villaIcon from "../assets/appvilla.png";
// import studioIcon from "../assets/appstudio.png";
// import plotIcon from "../assets/appplot.png";
// import agricultureLandIcon from "../assets/appagri.png";
// import farmHouseIcon from "../assets/appfarm.png";
// import uploadImageIcon from '../assets/appimage.png';
// import uploadVideoIcon from '../assets/appvideo.png';
// import youtubeIcon from '../assets/appyoutu.png';
// import OfficeIcon from '../assets/officecomm.png';
// import ShowroomIcon from '../assets/showcomm.png';
// import RetailShopIcon from '../assets/retailcomm.png';
// import WarehouseIcon from '../assets/ware comm.png';
// import CommercialPlotIcon from '../assets/plotcomm.png';
// import OthersIcon from '../assets/otherscomm.png';
// import liftIcon from '../assets/applift.png';
// import cctvIcon from '../assets/appctv.png';
// import gymIcon from '../assets/appfit.png';
// import gardenIcon from '../assets/appgarden.png';
// import kidsAreaIcon from '../assets/appkids.png';
// import sportsIcon from '../assets/appsport.png';
// import swimmingPoolIcon from '../assets/appswim.png';
// import intercomIcon from '../assets/appinter.png';
// import gatedCommunityIcon from '../assets/appgate.png';
// import clubHouseIcon from '../assets/appclub.png';
// import communityHallIcon from '../assets/appcom.png';
// import regularWaterSupplyIcon from '../assets/appregul.png';
// import powerBackupIcon from '../assets/apppower.png';
// import petAllowedIcon from '../assets/apppet.png';
// import diningTableIcon from '../assets/appdinner.png';
// import washingMachineIcon from '../assets/appwash.png';
// import sofaIcon from '../assets/appsofa.png';
// import microwaveIcon from '../assets/appmicro.png';
// import fridgeIcon from '../assets/appfridge.png';
// import waterPurifierIcon from '../assets/appwater.png';
// import gasPipelineIcon from '../assets/appgas.png';
// import acIcon from '../assets/appac.png';
// import bedIcon from '../assets/appbed.png';
// import tvIcon from '../assets/apptv.png';
// import cupboardIcon from '../assets/appcup.png';
// import geyserIcon from '../assets/appgeyser.png';

// // Styled Components for Stepper
// const CustomStepConnector = styled('div')(({ theme }) => ({
//   width: 2,
//   height: 40,
//   backgroundColor: '#e0e0e0',
//   marginLeft: 13,
//   marginTop: 4,
//   marginBottom: 4,
// }));

// const CustomStepConnectorHorizontal = styled('div')(({ theme }) => ({
//   width: 50,
//   height: 2,
//   backgroundColor: '#e0e0e0',
// }));

// const CustomStepIcon = ({ active, completed, isMobile }) => {
//   const size = isMobile ? 24 : 28;
//   const innerSize = isMobile ? 12 : 14;
  
//   if (completed) {
//     return <CheckCircleIcon sx={{ color: '#4caf50', fontSize: size }} />; 
//   }
  
//   if (active) {
//     return (
//       <Box
//         sx={{
//           width: size,
//           height: size,
//           borderRadius: '50%',
//           border: '3px solid #1976d2',
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'center',
//           backgroundColor: 'white',
//         }}
//       >
//         <Box
//           sx={{
//             width: innerSize,
//             height: innerSize,
//             borderRadius: '50%',
//             backgroundColor: '#1976d2',
//           }}
//         />
//       </Box>
//     );
//   }
  
//   return <RadioButtonUncheckedIcon sx={{ color: '#e0e0e0', fontSize: size }} />;
// };

// // Society amenities and furnishing facilities data
// const societyAmenities = [
//   { name: "Lift", icon: liftIcon, selected: false},
//   { name: "CCTV", icon: cctvIcon, selected: false },
//   { name: "Gym", icon: gymIcon, selected: false },
//   { name: "Garden", icon: gardenIcon, selected: false },
//   { name: "Kids Area", icon: kidsAreaIcon, selected: false },
//   { name: "Sports", icon: sportsIcon, selected: false },
//   { name: "Swimming Pool", icon: swimmingPoolIcon, selected: false },
//   { name: "Intercom", icon: intercomIcon, selected: false },
//   { name: "Gated Community", icon: gatedCommunityIcon, selected: false },
//   { name: "Club House", icon: clubHouseIcon, selected: false },
//   { name: "Community Hall", icon: communityHallIcon, selected: false },
//   { name: "Regular Water Supply", icon: regularWaterSupplyIcon, selected: false },
//   { name: "Power backup", icon: powerBackupIcon, selected: false },
//   { name: "Pet Allowed", icon: petAllowedIcon, selected: false },
// ];

// const furnishingFacilities = [
//   { name: "Dining Table", icon: diningTableIcon, selected: false},
//   { name: "Washing Machine", icon: washingMachineIcon, selected: false },
//   { name: "Sofa", icon: sofaIcon, selected: false },
//   { name: "Microwave", icon: microwaveIcon, selected: false },
//   { name: "Fridge", icon: fridgeIcon, selected: false },
//   { name: "Water Purifier", icon: waterPurifierIcon, selected: false },
//   { name: "Gas Pipeline", icon: gasPipelineIcon, selected: false },
//   { name: "AC", icon: acIcon, selected: false },
//   { name: "Bed", icon: bedIcon, selected: false },
//   { name: "TV", icon: tvIcon, selected: false },
//   { name: "Cupboard", icon: cupboardIcon, selected: false },
//   { name: "Geyser", icon: geyserIcon, selected: false },
// ];

// // Amenities Dialog Component (keeping your existing implementation)
// const AmenitiesDialog = ({ open, onClose, onSave, initialAmenities }) => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
//   const [societyAmenitiesList, setSocietyAmenitiesList] = useState(societyAmenities);
//   const [furnishingFacilitiesList, setFurnishingFacilitiesList] = useState(furnishingFacilities);
//   const [selectedOtherFacilities, setSelectedOtherFacilities] = useState([]);

//   useEffect(() => {
//     if (open && initialAmenities) {
//       if (initialAmenities.societyAmenitiesList) {
//         setSocietyAmenitiesList(initialAmenities.societyAmenitiesList);
//       } else {
//         setSocietyAmenitiesList(societyAmenities);
//       }
      
//       if (initialAmenities.furnishingFacilitiesList) {
//         setFurnishingFacilitiesList(initialAmenities.furnishingFacilitiesList);
//       } else {
//         setFurnishingFacilitiesList(furnishingFacilities);
//       }
      
//       if (initialAmenities.selectedOtherFacilities) {
//         setSelectedOtherFacilities(initialAmenities.selectedOtherFacilities);
//       } else {
//         setSelectedOtherFacilities([]);
//       }
//     } else if (open && !initialAmenities) {
//       setSocietyAmenitiesList(societyAmenities.map(a => ({ ...a, selected: false })));
//       setFurnishingFacilitiesList(furnishingFacilities.map(f => ({ ...f, selected: false })));
//       setSelectedOtherFacilities([]);
//     }
//   }, [open, initialAmenities]);

//   const toggleSocietyAmenity = (index) => {
//     const updatedAmenities = [...societyAmenitiesList];
//     updatedAmenities[index].selected = !updatedAmenities[index].selected;
//     setSocietyAmenitiesList(updatedAmenities);
//   };

//   const toggleFurnishingFacility = (index) => {
//     const updatedFacilities = [...furnishingFacilitiesList];
//     updatedFacilities[index].selected = !updatedFacilities[index].selected;
//     setFurnishingFacilitiesList(updatedFacilities);
//   };

//   const toggleOtherFacility = (facilityName) => {
//     setSelectedOtherFacilities(prev => {
//       if (prev.includes(facilityName)) {
//         return prev.filter(f => f !== facilityName);
//       } else {
//         return [...prev, facilityName];
//       }
//     });
//   };

//   const handleSave = () => {
//     onSave({
//       societyAmenitiesList,
//       furnishingFacilitiesList,
//       selectedOtherFacilities
//     });
//     onClose();
//   };

//   const handleCancel = () => {
//     const clearedSocietyAmenities = societyAmenities.map(amenity => ({
//       ...amenity,
//       selected: false
//     }));
    
//     const clearedFurnishingFacilities = furnishingFacilities.map(facility => ({
//       ...facility,
//       selected: false
//     }));
    
//     setSocietyAmenitiesList(clearedSocietyAmenities);
//     setFurnishingFacilitiesList(clearedFurnishingFacilities);
//     setSelectedOtherFacilities([]);
    
//     onSave({
//       societyAmenitiesList: clearedSocietyAmenities,
//       furnishingFacilitiesList: clearedFurnishingFacilities,
//       selectedOtherFacilities: []
//     });
    
//     onClose();
//   };

//   return (
//     <Dialog
//       open={open}
//       onClose={onClose}
//       maxWidth={isMobile ? "sm" : "lg"}
//       fullWidth
//       fullScreen={isMobile}
//       sx={{
//         '& .MuiDialog-paper': {
//           borderRadius: isMobile ? 0 : '24px',
//           maxHeight: isMobile ? '100vh' : '90vh',
//           margin: isMobile ? 0 : theme.spacing(2),
//         }
//       }}
//     >
//       <DialogContent sx={{ p: isMobile ? 2 : 4, pb: isMobile ? 10 : 4 }}>
//         <Typography 
//           variant={isMobile ? "h5" : "h4"}
//           sx={{ 
//             fontFamily: 'Outfit',
//             fontWeight: 500,
//             color: 'black',
//             mb: isMobile ? 2 : 4,
//             textAlign: isMobile ? 'center' : 'left'
//           }}
//         >
//           Add Property Amenities
//         </Typography>
        
//         {/* Society Amenities */}
//         <Box sx={{ mb: isMobile ? 3 : 4 }}>
//           <Typography 
//             variant={isMobile ? "h6" : "h5"}
//             sx={{ 
//               fontFamily: 'Outfit',
//               fontWeight: 500,
//               color: '#666',
//               mb: 2,
//               fontSize: isMobile ? '18px' : '24px'
//             }}
//           >
//             Society Amenities
//           </Typography>
//           <Grid container spacing={isMobile ? 1.5 : 2}>
//             {societyAmenitiesList.map((amenity, index) => (
//               <Grid item xs={6} sm={4} md={2.4} key={`society-${index}`}>
//                 <Card
//                   onClick={() => toggleSocietyAmenity(index)}
//                   sx={{
//                     height: isMobile ? 100 : 120,
//                     cursor: 'pointer',
//                     border: amenity.selected ? '2px solid #4f26ff' : '1px solid #d0d0d0',
//                     backgroundColor: amenity.selected ? '#eeeaff' : 'white',
//                     display: 'flex',
//                     flexDirection: 'column',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     p: 1,
//                     borderRadius: '12px',
//                     transition: 'all 0.2s ease',
//                     '&:hover': {
//                       borderColor: '#4f26ff',
//                       transform: 'translateY(-2px)',
//                       boxShadow: '0 4px 12px rgba(79, 38, 255, 0.15)'
//                     },
//                   }}
//                 >
//                   <CardContent sx={{ 
//                     display: 'flex', 
//                     flexDirection: 'column', 
//                     alignItems: 'center', 
//                     p: `${isMobile ? 6 : 8}px !important`,
//                     textAlign: 'center'
//                   }}>
//                     <Box
//                       component="img"
//                       src={amenity.icon}
//                       alt={amenity.name}
//                       sx={{ 
//                         width: isMobile ? 30 : 40, 
//                         height: isMobile ? 30 : 40, 
//                         mb: 0.5,
//                         objectFit: 'contain' 
//                       }}
//                     />
//                     <Typography
//                       sx={{
//                         textAlign: 'center',
//                         fontSize: isMobile ? '12px' : '14px',
//                         fontFamily: 'Outfit',
//                         color: amenity.selected ? '#4f26ff' : 'black',
//                         fontWeight: amenity.selected ? 500 : 400,
//                         lineHeight: 1.2,
//                         wordBreak: 'break-word',
//                       }}
//                     >
//                       {amenity.name}
//                     </Typography>
//                   </CardContent>
//                 </Card>
//               </Grid>
//             ))}
//           </Grid>
//         </Box>
        
//         {/* Furnishing Facilities */}
//         <Box sx={{ mb: isMobile ? 3 : 4 }}>
//           <Typography 
//             variant={isMobile ? "h6" : "h5"}
//             sx={{ 
//               fontFamily: 'Outfit',
//               fontWeight: 500,
//               color: '#666',
//               mb: 2,
//               fontSize: isMobile ? '18px' : '24px'
//             }}
//           >
//             Furnishing Facilities
//           </Typography>
//           <Grid container spacing={isMobile ? 1.5 : 2}>
//             {furnishingFacilitiesList.map((facility, index) => (
//               <Grid item xs={6} sm={4} md={2.4} key={`furnishing-${index}`}>
//                 <Card
//                   onClick={() => toggleFurnishingFacility(index)}
//                   sx={{
//                     height: isMobile ? 100 : 120,
//                     cursor: 'pointer',
//                     border: facility.selected ? '2px solid #4f26ff' : '1px solid #d0d0d0',
//                     backgroundColor: facility.selected ? '#eeeaff' : 'white',
//                     display: 'flex',
//                     flexDirection: 'column',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     p: 1,
//                     borderRadius: '12px',
//                     transition: 'all 0.2s ease',
//                     '&:hover': {
//                       borderColor: '#4f26ff',
//                       transform: 'translateY(-2px)',
//                       boxShadow: '0 4px 12px rgba(79, 38, 255, 0.15)'
//                     },
//                   }}
//                 >
//                   <CardContent sx={{ 
//                     display: 'flex', 
//                     flexDirection: 'column', 
//                     alignItems: 'center', 
//                     p: `${isMobile ? 6 : 8}px !important`,
//                     textAlign: 'center'
//                   }}>
//                     <Box
//                       component="img"
//                       src={facility.icon}
//                       alt={facility.name}
//                       sx={{ 
//                         width: isMobile ? 30 : 40, 
//                         height: isMobile ? 30 : 40, 
//                         mb: 0.5,
//                         objectFit: 'contain' 
//                       }}
//                     />
//                     <Typography
//                       sx={{
//                         textAlign: 'center',
//                         fontSize: isMobile ? '12px' : '14px',
//                         fontFamily: 'Outfit',
//                         color: facility.selected ? '#4f26ff' : 'black',
//                         fontWeight: facility.selected ? 500 : 400,
//                         lineHeight: 1.2,
//                         wordBreak: 'break-word'
//                       }}
//                     >
//                       {facility.name}
//                     </Typography>
//                   </CardContent>
//                 </Card>
//               </Grid>
//             ))}
//           </Grid>
//         </Box>
        
//         {/* Other Facilities */}
//         <Box sx={{ mb: isMobile ? 3 : 4 }}>
//           <Typography
//             variant={isMobile ? "h6" : "h5"}
//             sx={{ 
//               fontFamily: 'Outfit',
//               fontWeight: 500,
//               color: '#666',
//               mb: 2,
//               fontSize: isMobile ? '18px' : '24px'
//             }}
//           >
//             Other Facilities
//           </Typography>
//           <Grid container spacing={isMobile ? 1.5 : 2}>
//             {["Hospital", "School", "Park", "Shopping Mall", "Metro Station",
//               "Bus Stop", "Restaurant", "Pharmacy"].map((facility, index) => (
//               <Grid item xs={6} sm={4} md={3} key={`other-facility-${index}`}>
//                 <Card
//                   onClick={() => toggleOtherFacility(facility)}
//                   sx={{
//                     height: isMobile ? 60 : 70,
//                     cursor: 'pointer',
//                     border: selectedOtherFacilities.includes(facility) ? '2px solid #4f26ff' : '1px solid #d0d0d0',
//                     backgroundColor: selectedOtherFacilities.includes(facility) ? '#eeeaff' : 'white',
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     px: 2,
//                     borderRadius: '12px',
//                     transition: 'all 0.2s ease',
//                     '&:hover': {
//                       borderColor: '#4f26ff',
//                       transform: 'translateY(-2px)',
//                       boxShadow: '0 4px 12px rgba(79, 38, 255, 0.15)'
//                     },
//                   }}
//                 >
//                   <CardContent sx={{ 
//                     display: 'flex', 
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     p: `${isMobile ? 8 : 12}px !important`,
//                     width: '100%'
//                   }}>
//                     <Typography
//                       sx={{
//                         textAlign: 'center',
//                         fontSize: isMobile ? '13px' : '15px',
//                         fontFamily: 'Outfit',
//                         color: selectedOtherFacilities.includes(facility) ? '#4f26ff' : 'black',
//                         fontWeight: selectedOtherFacilities.includes(facility) ? 500 : 400,
//                         lineHeight: 1.2,
//                         wordBreak: 'break-word'
//                       }}
//                     >
//                       {facility}
//                     </Typography>
//                   </CardContent>
//                 </Card>
//               </Grid>
//             ))}
//           </Grid>
//         </Box>
//       </DialogContent>
      
//       <DialogActions
//         sx={{
//           p: isMobile ? 2 : 3,
//           justifyContent: isMobile ? 'center' : 'space-between',
//           gap: isMobile ? 2 : 0,
//           position: isMobile ? 'fixed' : 'relative',
//           bottom: isMobile ? 0 : 'auto',
//           left: isMobile ? 0 : 'auto',
//           right: isMobile ? 0 : 'auto',
//           backgroundColor: 'white',
//           borderTop: isMobile ? '1px solid #e0e0e0' : 'none'
//         }}
//       >
//         <Button
//           onClick={handleCancel}
//           variant="contained"
//           sx={{
//             width: isMobile ? '50%' : 180,
//             height: isMobile ? 50 : 60,
//             bgcolor: '#c2c2c2',
//             borderRadius: '10px',
//             color: '#020202',
//             fontSize: isMobile ? 16 : 18,
//             fontFamily: "'Outfit', Helvetica",
//             '&:hover': {
//               bgcolor: '#b0b0b0'
//             }
//           }}
//         >
//           Cancel
//         </Button>
//         <Button
//           onClick={handleSave}
//           variant="contained"
//           sx={{
//             width: isMobile ? '50%' : 180,
//             height: isMobile ? 50 : 60,
//             bgcolor: '#4f26ff',
//             borderRadius: '10px',
//             color: 'white',
//             fontSize: isMobile ? 16 : 18,
//             fontFamily: "'Outfit', Helvetica",
//             '&:hover': {
//               bgcolor: '#3d1fd9'
//             }
//           }}
//         >
//           OK
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

// // Selected Amenities Display Component
// const SelectedAmenitiesDisplay = ({ selectedAmenities }) => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

//   if (!selectedAmenities) return null;

//   const { societyAmenitiesList, furnishingFacilitiesList, selectedOtherFacilities } = selectedAmenities;

//   const selectedSocietyAmenities = societyAmenitiesList
//     .filter(amenity => amenity.selected)
//     .map(amenity => amenity.name);

//   const selectedFurnishingFacilities = furnishingFacilitiesList
//     .filter(facility => facility.selected)
//     .map(facility => facility.name);

//   const hasSelectedAmenities = selectedSocietyAmenities.length > 0;
//   const hasSelectedFacilities = selectedFurnishingFacilities.length > 0;
//   const hasOtherFacilities = selectedOtherFacilities && selectedOtherFacilities.length > 0;

//   if (!hasSelectedAmenities && !hasSelectedFacilities && !hasOtherFacilities) {
//     return null;
//   }

//   return (
//     <Box sx={{ mt: isMobile ? 2 : 3, mb: isMobile ? 2 : 3 }}>
//       {hasSelectedAmenities && (
//         <Box sx={{ mb: 2 }}>
//           <Typography
//             component="span"
//             sx={{
//               fontSize: isMobile ? 14 : 16,
//               fontWeight: "medium",
//               fontFamily: "'Outfit', Helvetica",
//               color: "text.secondary",
//               mr: 1,
//             }}
//           >
//             Society Amenities:
//           </Typography>
//           <Typography
//             component="span"
//             sx={{
//               fontSize: isMobile ? 14 : 16,
//               fontWeight: "normal",
//               fontFamily: "'Outfit', Helvetica",
//               color: "primary.main"
//             }}
//           >
//             {selectedSocietyAmenities.join(', ')}.
//           </Typography>
//         </Box>
//       )}
      
//       {hasSelectedFacilities && (
//         <Box sx={{ mb: 2 }}>
//           <Typography
//             component="span"
//             sx={{
//               fontSize: isMobile ? 14 : 16,
//               fontWeight: "medium",
//               fontFamily: "'Outfit', Helvetica",
//               color: "text.secondary",
//               mr: 1,
//             }}
//           >
//             Furnishing Facilities:
//           </Typography>
//           <Typography
//             component="span"
//             sx={{
//               fontSize: isMobile ? 14 : 16,
//               fontWeight: "normal",
//               fontFamily: "'Outfit', Helvetica",
//               color: "primary.main"
//             }}
//           >
//             {selectedFurnishingFacilities.join(', ')}.
//           </Typography>
//         </Box>
//       )}

//       {hasOtherFacilities && (
//         <Box>
//           <Typography
//             component="span"
//             sx={{
//               fontSize: isMobile ? 14 : 16,
//               fontWeight: "medium",
//               fontFamily: "'Outfit', Helvetica",
//               color: "text.secondary",
//               mr: 1,
//             }}
//           >
//             Other Facilities:
//           </Typography>
//           <Typography
//             component="span"
//             sx={{
//               fontSize: isMobile ? 14 : 16,
//               fontWeight: "normal",
//               fontFamily: "'Outfit', Helvetica",
//               color: "primary.main"
//             }}
//           >
//             {selectedOtherFacilities.join(', ')}.
//           </Typography>
//         </Box>
//       )}
//     </Box>
//   );
// };

// // Main PropertyDetails Component
// const PropertyDetails = () => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//   const navigate = useNavigate();
//   const location = useLocation();

//   const {
//     propertyType = 'Residential',
//     category = 'Sell',
//     location: propLocation = ''
//   } = location.state || {};

//   const user = useSelector(selectUser);
//   const userId = user?.id;

//   // All state variables (keeping your existing state management)
//   const [profileData, setProfileData] = useState(null);
//   const [loadingProfile, setLoadingProfile] = useState(true);
//   const [propertyImages, setPropertyImages] = useState([]);
//   const [propertyVideos, setPropertyVideos] = useState([]);
//   const [buildingName, setBuildingName] = useState('');
//   const [areaName, setAreaName] = useState('');
//   const [completeAddress, setCompleteAddress] = useState('');
//   const [locality, setLocality] = useState('');
//   const [landmark, setLandmark] = useState('');
//   const [propertyDescription, setPropertyDescription] = useState('');
//   const [propertyContent, setPropertyContent] = useState('');
//   const [propertySize, setPropertySize] = useState('');
//   const [selectedUnit, setSelectedUnit] = useState('sq.ft');
//   const [propertyLength, setPropertyLength] = useState('');
//   const [propertyWidth, setPropertyWidth] = useState('');
//   const [totalFloors, setTotalFloors] = useState('');
//   const [selectedFloor, setSelectedFloor] = useState('');
//   const [ownerName, setOwnerName] = useState('');
//   const [contactNumber, setContactNumber] = useState('');
//   const [emailAddress, setEmailAddress] = useState('');
//   const [youtubeLink, setYoutubeLink] = useState('');
//   const [carpetArea, setCarpetArea] = useState('');
//   const [carpetAreaUnits, setCarpetAreaUnits] = useState('Sq.Ft');
//   const [builtUpArea, setBuiltUpArea] = useState('');
//   const [builtUpAreaUnits, setBuiltUpAreaUnits] = useState('Sq.Ft');
//   const [udsArea, setUdsArea] = useState('');
//   const [udsAreaUnits, setUdsAreaUnits] = useState('Sq.Ft');
//   const [selectedBHK, setSelectedBHK] = useState("");
//   const [selectedFurnish, setSelectedFurnish] = useState("");
//   const [selectedHub, setSelectedHub] = useState('');
//   const [selectedStatus, setSelectedStatus] = useState('');
//   const [selectedOwnership, setSelectedOwnership] = useState('');
//   const [floorsAvailable, setFloorsAvailable] = useState("");
  
//   const [areaSuggestions, setAreaSuggestions] = useState([]);
//   const [showAreaSuggestions, setShowAreaSuggestions] = useState(false);
//   const [areaAnchorEl, setAreaAnchorEl] = useState(null);
//   const [selectedAreaDetails, setSelectedAreaDetails] = useState(null);
  
//   const [amenitiesDialogOpen, setAmenitiesDialogOpen] = useState(false);
//   const [selectedAmenities, setSelectedAmenities] = useState(null);
//   const [selectedImageIndex, setSelectedImageIndex] = useState(0);
//   const [previewOpen, setPreviewOpen] = useState(false);
//   const [imagePreviews, setImagePreviews] = useState([]);
  
//   const [errors, setErrors] = useState({});
//   const [touchedFields, setTouchedFields] = useState({});

//   const isCommercial = propertyType === 'Commercial';

//   // Property types
//   const [residentialPropertyTypes, setResidentialPropertyTypes] = useState([
//     { id: "apartment", name: "Apartment", icon: apartmentIcon, selected: true },
//     { id: "independent-house", name: "Independent House", icon: independentHouseIcon, selected: false },
//     { id: "pent-house", name: "Pent House", icon: pentHouseIcon, selected: false },
//     { id: "studio", name: "Studio", icon: studioIcon, selected: false },
//     { id: "plot", name: "plot", icon: plotIcon, selected: false },
//     { id: "agriculture-land", name: "Agriculture Land", icon: agricultureLandIcon, selected: false },
//     { id: "farm-house", name: "Farm House", icon: farmHouseIcon, selected: false },
//   ]);

//   const [commercialPropertyTypes, setCommercialPropertyTypes] = useState([
//     { id: "office", name: "Office", icon: OfficeIcon, selected: true },
//     { id: "showroom", name: "Showroom", icon: ShowroomIcon, selected: false },
//     { id: "retail-shop", name: "Retail Shop", icon: RetailShopIcon, selected: false },
//     { id: "warehouse", name: "Warehouse", icon: WarehouseIcon, selected: false },
//     { id: "plot", name: "plot", icon: CommercialPlotIcon, selected: false },
//     { id: "others", name: "Others", icon: OthersIcon, selected: false },
//   ]);

//   const [selectedPropertyType, setSelectedPropertyType] = useState(() => {
//     if (isCommercial) {
//       return commercialPropertyTypes.find(t => t.selected)?.id || "office";
//     }
//     return residentialPropertyTypes.find(t => t.selected)?.id || "apartment";
//   });

//   const bhkOptions = [
//     { id: "1bhk", label: "1 BHK" },
//     { id: "2bhk", label: "2 BHK" },
//     { id: "3bhk", label: "3 BHK" },
//     { id: "4bhk", label: "4 BHK" },
//     { id: "5bhk", label: "5 BHK" },
//     { id: "6bhk", label: "6 BHK" },
//     { id: "6+bhk", label: "6+ BHK" },
//   ];

//   const furnishTypes = [
//     { id: "fully", label: "Fully Furnished" },
//     { id: "semi", label: "Semi Furnished" },
//     { id: "un", label: "Un Furnished" },
//   ];

//   const hubs = ['IT Park', 'Business Park', 'Others'];
//   const statuses = ['Ready to Occupy', 'Under Construction', 'Bare shell'];
//   const ownerships = ['Freehold', 'Leasehold', 'Cooperative society', 'Power of attorney'];

//   // Validation functions (keeping your existing validation logic)
//   const validateAlphanumeric = (text, fieldName) => {
//     if (!text || !text.trim()) return `${fieldName} is required`;
//     if (text.trim().length < 3) return `${fieldName} must be at least 3 characters`;
//     return "";
//   };

//   const validateName = (name) => {
//     if (!name || !name.trim()) return "Name is required";
//     if (name.trim().length < 3) return "Name must be at least 3 characters";
//     return "";
//   };

//   const validateNumber = (value, fieldName, min = 1, max = null) => {
//     if (!value || value === "") return `${fieldName} is required`;
//     const numValue = Number(value);
//     if (isNaN(numValue)) return `${fieldName} must be a number`;
//     if (numValue < min) return `${fieldName} must be at least ${min}`;
//     if (max !== null && numValue > max) return `${fieldName} must be less than ${max}`;
//     return "";
//   };

//   const validateEmail = (email) => {
//     if (!email || !email.trim()) return "Email is required";
//     const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
//     if (!emailRegex.test(email)) return "Please enter a valid email address";
//     return "";
//   };

//   const validatePhone = (phone) => {
//     if (!phone || !phone.trim()) return "Phone number is required";
//     const phoneRegex = /^[0-9]{10}$/;
//     if (!phoneRegex.test(phone)) return "Phone must be exactly 10 digits";
//     return "";
//   };

//   const validateCompleteAddress = (value) => {
//     if (!value || !value.trim()) return "Complete address is required";
//     if (value.trim().length < 10) return "Complete address must be at least 10 characters";
//     return "";
//   };

//   const validateYouTubeLink = (link) => {
//     if (!link || !link.trim()) return "";
//     const youtubeRegex = /^(https?:\/\/)?(www\.)?(youtube\.com\/watch\?v=|youtu\.be\/)[a-zA-Z0-9\\_-]{11}(\?.*)?$/;
//     if (!youtubeRegex.test(link)) return "Please enter a valid YouTube video link";
//     return "";
//   };

//   const validateUdsArea = (value, propertyType) => {
//     const selectedType = getSelectedPropertyType();
//     const typeId = propertyType || selectedType?.id;
    
//     if (typeId === 'independent-house') {
//       if (!value || value.trim() === "") {
//         return "UDS (Undivided Share) is required for Independent House properties";
//       }
//     }
    
//     if (!value || value === "") return "";
    
//     const numValue = Number(value);
//     if (isNaN(numValue)) return "UDS area must be a number";
//     if (numValue < 1) return "UDS area must be at least 1";
//     return "";
//   };

//   // Get selected property type
//   const getSelectedPropertyType = () => {
//     if (isCommercial) {
//       return commercialPropertyTypes.find(type => type.selected) || commercialPropertyTypes[0];
//     }
//     return residentialPropertyTypes.find(type => type.selected) || residentialPropertyTypes[0];
//   };

//   // Area handlers
//   const handleAreaNameChange = (e) => {
//     const value = e.target.value;
//     setAreaName(value);
//     setAreaAnchorEl(e.currentTarget);
    
//     if (!value) {
//       setErrors(prev => ({...prev, areaName: 'Area Name is required'}));
//     } else if (value.trim().length < 1) {
//       setErrors(prev => ({...prev, areaName: 'Area Name must be at least 3 characters'}));
//     } else {
//       setErrors(prev => ({...prev, areaName: ''}));
//     }
//   };

//   const handleSelectArea = (area) => {
//     setAreaName(area.area);
//     setSelectedAreaDetails({
//       name: area.area,
//       address: area.address,
//       location: area.location
//     });
//     setAreaAnchorEl(null);
//     setShowAreaSuggestions(false);
//     setErrors(prev => ({...prev, areaName: ''}));
//   };

//   const handleAreaClickAway = () => {
//     setShowAreaSuggestions(false);
//   };

//   const fetchAreaSuggestions = async (query, city) => {
//     if (query.length < 1 || !city) return;
    
//     try {
//       const response = await fetch(`https://propertydealstalk.com/api/property/getAreasByCity?city=${encodeURIComponent(city)}&q=${encodeURIComponent(query)}`);
//       const data = await response.json();
      
//       if (data.success && data.areas && data.areas.length > 0) {
//         const transformedAreas = data.areas.map(area => ({
//           area: area.name,
//           address: area.address,
//           location: area.location
//         }));
        
//         setAreaSuggestions(transformedAreas);
//         setShowAreaSuggestions(true);
//       } else {
//         setAreaSuggestions([]);
//         setShowAreaSuggestions(false);
//       }
//     } catch (error) {
//       console.error('Error fetching area suggestions:', error);
//       setAreaSuggestions([]);
//       setShowAreaSuggestions(false);
//     }
//   };

//   useEffect(() => {
//     if (areaName.trim().length > 0 && location.state?.location) {
//       fetchAreaSuggestions(areaName, location.state.location);
//     } else {
//       setAreaSuggestions([]);
//       setShowAreaSuggestions(false);
//     }
//   }, [areaName, location.state?.location]);

//   // Fetch user profile
//   useEffect(() => {
//     const fetchUserProfile = async () => {
//       if (!userId) {
//         setLoadingProfile(false);
//         return;
//       }
      
//       try {
//         setLoadingProfile(true);
//         const response = await fetch(`https://propertydealstalk.com/api/users/getUserProfile?user_id=${userId}`);
//         const data = await response.json();
        
//         if (data.status === "SUCCESS") {
//           setProfileData(data.result);
          
//           if (data.result.full_name) {
//             setOwnerName(data.result.full_name);
//           } else {
//             setOwnerName('N/A');
//           }
          
//           if (data.result.contact_number) {
//             setContactNumber(data.result.contact_number);
//           } else {
//             setContactNumber('N/A');
//           }
          
//           if (data.result.email_id) {
//             setEmailAddress(data.result.email_id);
//           } else {
//             setEmailAddress('N/A');
//           }
//         }
//       } catch (err) {
//         console.error('Error fetching profile:', err);
//       } finally {
//         setLoadingProfile(false);
//       }
//     };
    
//     fetchUserProfile();
//   }, [userId]);

//   // Image upload handler
//   const handleImageUpload = (event) => {
//     const files = event.target.files;
//     if (!files || files.length === 0) return;
    
//     if (files.length > 10) {
//       alert("You can only upload up to 10 images");
//       return;
//     }
    
//     const validFiles = Array.from(files).filter(file => {
//       return file.type.startsWith('image/');
//     });
    
//     if (validFiles.length !== files.length) {
//       alert("Only image files are allowed (JPEG, PNG, GIF, etc.)");
//       return;
//     }
    
//     const newPreviews = [];
//     const processedFiles = [];
    
//     const fileProcessPromises = validFiles.map(file => {
//       return new Promise((resolve) => {
//         const reader = new FileReader();
//         reader.onload = (e) => {
//           const base64Data = e.target.result;
          
//           const img = new Image();
//           img.onload = () => {
//             const preview = URL.createObjectURL(file);
            
//             newPreviews.push(preview);
//             processedFiles.push({
//               name: file.name,
//               type: file.type,
//               size: file.size,
//               lastModified: file.lastModified,
//               base64: base64Data
//             });
//             resolve();
//           };
          
//           img.onerror = () => {
//             console.error(`Failed to load image: ${file.name}`);
//             resolve();
//           };
          
//           img.src = base64Data;
//         };
        
//         reader.onerror = () => {
//           console.error(`Failed to read file: ${file.name}`);
//           resolve();
//         };
        
//         reader.readAsDataURL(file);
//       });
//     });
    
//     Promise.all(fileProcessPromises).then(() => {
//       setImagePreviews(prevPreviews => {
//         prevPreviews.forEach(preview => URL.revokeObjectURL(preview));
//         return newPreviews;
//       });
      
//       setPropertyImages(validFiles);
//     });
//   };

//   // Cleanup previews
//   useEffect(() => {
//     return () => {
//       imagePreviews.forEach(preview => URL.revokeObjectURL(preview));
//     };
//   }, [imagePreviews]);

//   // Property type selection handler
//   const handlePropertyTypeSelect = (typeId) => {
//     setSelectedPropertyType(typeId);
//     setErrors({
//       ...errors,
//       bhk: '',
//       furnish: '',
//       propertyDescription: '',
//       propertyContent: '',
//       propertyLength: '',
//       propertyWidth: '',
//       locality: ''
//     });
    
//     if (isCommercial) {
//       const updatedTypes = commercialPropertyTypes.map(type => ({
//         ...type,
//         selected: type.id === typeId
//       }));
//       setCommercialPropertyTypes(updatedTypes);
//     } else {
//       const updatedTypes = residentialPropertyTypes.map(type => ({
//         ...type,
//         selected: type.id === typeId
//       }));
//       setResidentialPropertyTypes(updatedTypes);
//     }
//   };

//   // Amenities handlers
//   const handleOpenAmenitiesDialog = () => {
//     setAmenitiesDialogOpen(true);
//   };

//   const handleCloseAmenitiesDialog = () => {
//     setAmenitiesDialogOpen(false);
//   };

//   const handleSaveAmenities = (amenities) => {
//     setSelectedAmenities(amenities);
//     setErrors({...errors, amenities: ''});
//   };

//   // Navigation handlers
//   const handleBack = () => {
//     navigate('/add-new-property', { 
//       state: {
//         propertyType: propertyType,
//         category: category,
//         location: location.state?.location || propLocation || localStorage.getItem('propertyLocation') || '',
//         asset_type: getSelectedPropertyType()?.name || '',
//         selectedType: getSelectedPropertyType()?.id || ''
//       } 
//     });
//   };

//   const handleNext = () => {
//     let selectedType = null;
//     if (isCommercial) {
//       selectedType = commercialPropertyTypes.find(type => type.selected);
//     } else {
//       selectedType = residentialPropertyTypes.find(type => type.selected);
//     }
    
//     const isPlot = selectedType?.id === 'plot';
//     const isAgricultureLand = selectedType?.id === 'agriculture-land';
    
//     let validationErrors = {
//       buildingName: validateAlphanumeric(buildingName, "Building name"),
//       areaName: validateName(areaName),
//       ...(selectedType?.id !== 'apartment' && {
//         propertySize: validateNumber(propertySize, "Property size")
//       })
//     };
    
//     if (isPlot || isAgricultureLand) {
//       validationErrors = {
//         ...validationErrors,
//         completeAddress: validateCompleteAddress(completeAddress),
//         propertyLength: validateNumber(propertyLength, "Length"),
//         propertyWidth: validateNumber(propertyWidth, "Width"),
//       };
      
//       if (isPlot) {
//         validationErrors.propertyDescription = validateName(propertyDescription);
//         validationErrors.propertyContent = validateName(propertyContent);
//       }
//     }
//     else if (selectedType?.id === 'independent-house') {
//       validationErrors.udsArea = validateUdsArea(udsArea, selectedType?.id);
//       validationErrors.completeAddress = validateCompleteAddress(completeAddress);
      
//       if (!isCommercial) {
//         validationErrors = {
//           ...validationErrors,
//           ownerName: (ownerName === 'N/A' || !ownerName) ? 'Owner name is required' : validateName(ownerName),
//           contactNumber: (contactNumber === 'N/A' || !contactNumber) ? 'Contact number is required' : validatePhone(contactNumber),
//           emailAddress: (emailAddress === 'N/A' || !emailAddress) ? 'Email address is required' : validateEmail(emailAddress),
//           bhk: selectedBHK ? '' : 'Please select BHK',
//           furnish: selectedFurnish ? '' : 'Please select furnish type',
//         };
//       }
//     }
//     else if (selectedType?.id === 'apartment' || selectedType?.id === 'duplex') {
//       if (udsArea && udsArea.trim() !== '') {
//         validationErrors.udsArea = validateUdsArea(udsArea, selectedType?.id);
//       }
      
//       validationErrors.completeAddress = validateCompleteAddress(completeAddress);
      
//       if (!isCommercial) {
//         validationErrors = {
//           ...validationErrors,
//           ownerName: (ownerName === 'N/A' || !ownerName) ? 'Owner name is required' : validateName(ownerName),
//           contactNumber: (contactNumber === 'N/A' || !contactNumber) ? 'Contact number is required' : validatePhone(contactNumber),
//           emailAddress: (emailAddress === 'N/A' || !emailAddress) ? 'Email address is required' : validateEmail(emailAddress),
//           bhk: selectedBHK ? '' : 'Please select BHK',
//           furnish: selectedFurnish ? '' : 'Please select furnish type',
//         };
//       }
//     }
//     else if (isCommercial) {
//       validationErrors = {
//         ...validationErrors,
//         totalFloors: validateNumber(totalFloors, "Total floors", 1, 100),
//         selectedFloor: selectedFloor ? '' : 'Please select floor',
//       };
//     }
    
//     if (youtubeLink && youtubeLink.trim()) {
//       validationErrors.youtubeLink = validateYouTubeLink(youtubeLink);
//     }
    
//     setErrors(validationErrors);
    
//     const hasErrors = Object.values(validationErrors).some(error => error);
    
//     if (hasErrors) {
//       const firstErrorField = Object.keys(validationErrors).find(key => validationErrors[key]);
//       if (firstErrorField) {
//         const element = document.getElementById(firstErrorField);
//         if (element) {
//           element.scrollIntoView({ behavior: 'smooth', block: 'center' });
//           element.focus();
//         }
//       }
//       return;
//     }
    
//     const propertyDetails = {
//       propertyType: isCommercial ? 'Commercial' : 'Residential',
//       category: category,
//       location: location.state?.location || propLocation || '',
//       asset_type: selectedType?.name || '',
//       selectedType: selectedType?.id || '',
//       property_name: buildingName || '',
//       buildingName: buildingName || '',
//       area_name: areaName || '',
//       areaName: areaName || '',
//       landmark: landmark || '',
//       description: (isPlot ? propertyDescription : '') || '',
//       content: (isPlot ? propertyContent : '') || '',
//       propertyDescription: propertyDescription || '',
//       propertyContent: propertyContent || '',
//       bhk: (!isPlot && !isAgricultureLand && !isCommercial) ? (selectedBHK || '') : '',
//       furnish_type: (!isPlot && !isAgricultureLand && !isCommercial) ? (selectedFurnish || '') : '',
//       full_address: completeAddress || '',
//       completeAddress: completeAddress || '',
//       locality: (!isPlot && !isAgricultureLand) ? (locality || '') : null,
//       carpet_area: (selectedType?.id === 'apartment' || selectedType?.id === 'independent-house' || selectedType?.id === 'duplex') ? (carpetArea || '') : '',
//       carpet_area_units: (selectedType?.id === 'apartment' || selectedType?.id === 'independent-house' || selectedType?.id === 'duplex') ? (carpetAreaUnits || '') : '',
//       built_up_area: (selectedType?.id === 'apartment' || selectedType?.id === 'independent-house' || selectedType?.id === 'duplex') ? (builtUpArea || '') : '',
//       built_up_area_units: (selectedType?.id === 'apartment' || selectedType?.id === 'independent-house' || selectedType?.id === 'duplex') ? (builtUpAreaUnits || '') : '',
//       uds_area: (selectedType?.id === 'apartment' || selectedType?.id === 'independent-house' || selectedType?.id === 'duplex') ? (udsArea || '') : '',
//       uds_area_units: (selectedType?.id === 'apartment' || selectedType?.id === 'independent-house' || selectedType?.id === 'duplex') ? (udsAreaUnits || 'Sq.Ft') : '',
//       property_size: propertySize || '',
//       propertySize: propertySize || '',
//       property_size_units: selectedUnit || 'sq.ft',
//       selectedUnit: selectedUnit || 'sq.ft',
//       length: propertyLength || '',
//       width: propertyWidth || '',
//       propertyLength: propertyLength || '',
//       propertyWidth: propertyWidth || '',
//       total_floors: (!isPlot && !isAgricultureLand) ? (totalFloors || '') : '',
//       totalFloors: (!isPlot && !isAgricultureLand) ? (totalFloors || '') : '',
//       select_floor: (!isPlot && !isAgricultureLand) ? (selectedFloor || '') : '',
//       selectedFloor: (!isPlot && !isAgricultureLand) ? (selectedFloor || '') : '',
//       propertyImages: propertyImages || [],
//       propertyVideos: propertyVideos || [],
//       youtube_link: youtubeLink?.trim() || '',
//       youtubeLink: youtubeLink?.trim() || '',
//       ownerName: (!isPlot && !isAgricultureLand && !isCommercial) ? (ownerName || '') : '',
//       contactNumber: (!isPlot && !isAgricultureLand && !isCommercial) ? (contactNumber || '') : '',
//       emailAddress: (!isPlot && !isAgricultureLand && !isCommercial) ? (emailAddress || '') : '',
//     };
    
//     if (isCommercial) {
//       propertyDetails.commercial_catgory = category.toLowerCase() === 'sell' ? 'sale' : 'rent';
//       propertyDetails.commercial_asset_type = selectedType?.name || '';
//       propertyDetails.hub = selectedHub || '';
//       propertyDetails.ownership = selectedOwnership || '';
//       propertyDetails.status = selectedStatus || '';
//       propertyDetails.floors_available = floorsAvailable || '';
//     }
    
//     if (!isPlot && !isAgricultureLand && selectedAmenities) {
//       const selectedSociety = selectedAmenities.societyAmenitiesList
//         ?.filter(a => a.selected)
//         .map(a => a.name) || [];
//       const selectedFurnishing = selectedAmenities.furnishingFacilitiesList
//         ?.filter(f => f.selected)
//         .map(f => f.name) || [];
//       const selectedOther = selectedAmenities.selectedOtherFacilities || [];
//       propertyDetails.society_aminities = selectedSociety.length > 0
//         ? selectedSociety.join(', ')
//         : null;
//       propertyDetails.furnish_facilities = selectedFurnishing.length > 0
//         ? selectedFurnishing.join(', ')
//         : null;
//       propertyDetails.other_facilities = selectedOther.length > 0
//         ? selectedOther.join(', ')
//         : null;
//       propertyDetails.facilities_distance = '1km';
//     }
    
//     if (category === 'Rent') {
//       navigate('/rent-details', { state: propertyDetails });
//     } else if (category === 'Sell') {
//       navigate('/price-details', { state: propertyDetails });
//     }
//   };

//   // Initialize commercial defaults
//   useEffect(() => {
//     if (isCommercial) {
//       if (!selectedHub) setSelectedHub('Business Park');
//       if (!selectedStatus) setSelectedStatus('Ready to Occupy');
//       if (!selectedOwnership) setSelectedOwnership('Freehold');
//     }
//   }, [isCommercial]);

//   // Render image upload section
//   const renderImageUploadSection = () => (
//     <Box sx={{ mb: 3 }}>
//       <Typography sx={{
//         fontSize: '13px',
//         fontWeight: 500,
//         color: '#333',
//         fontFamily: 'Outfit',
//         mb: 1
//       }}>
//         Upload Images
//       </Typography>
      
//       <Box
//         sx={{
//           height: 120,
//           border: '2px dashed #d0d0d0',
//           borderRadius: 2,
//           display: 'flex',
//           flexDirection: 'column',
//           alignItems: 'center',
//           justifyContent: 'center',
//           cursor: 'pointer',
//           transition: 'all 0.2s ease',
//           '&:hover': { 
//             backgroundColor: '#f9f9f9', 
//             borderColor: '#1976d2' 
//           },
//         }}
//         onClick={() => document.getElementById('property-images').click()}
//       >
//         <input
//           type="file"
//           id="property-images"
//           multiple
//           accept="image/*"
//           style={{ display: 'none' }}
//           onChange={handleImageUpload}
//         />
//         <CloudUpload sx={{ width: 40, height: 40, mb: 1, color: '#1976d2' }} />
//         <Typography sx={{
//           fontSize: '13px',
//           fontWeight: 500,
//           color: '#666',
//           fontFamily: 'Outfit',
//         }}>
//           Upload Images (Max 10)
//         </Typography>
//       </Box>
      
//       {imagePreviews && imagePreviews.length > 0 && (
//         <Box sx={{ mt: 2 }}>
//           <Typography sx={{
//             fontSize: '12px',
//             fontWeight: 500,
//             color: '#666',
//             fontFamily: 'Outfit',
//             mb: 1
//           }}>
//             {imagePreviews.length} {imagePreviews.length === 1 ? 'image' : 'images'} uploaded
//           </Typography>
          
//           <Box sx={{
//             display: 'flex',
//             flexWrap: 'wrap',
//             gap: 1,
//             maxHeight: '150px',
//             overflowY: 'auto',
//             p: 1,
//             border: '1px solid #e0e0e0',
//             borderRadius: 1,
//             backgroundColor: '#fafafa'
//           }}>
//             {imagePreviews.map((preview, index) => (
//               <Box
//                 key={`img-preview-${index}`}
//                 sx={{
//                   position: 'relative',
//                   width: '70px',
//                   height: '70px',
//                   borderRadius: 1,
//                   overflow: 'hidden',
//                   border: '1px solid #e0e0e0',
//                   cursor: 'pointer',
//                   flexShrink: 0
//                 }}
//                 onClick={() => {
//                   setSelectedImageIndex(index);
//                   setPreviewOpen(true);
//                 }}
//               >
//                 <Box
//                   component="img"
//                   src={preview}
//                   alt={`Preview ${index + 1}`}
//                   sx={{
//                     width: '100%',
//                     height: '100%',
//                     objectFit: 'cover',
//                   }}
//                 />
//                 <IconButton
//                   size="small"
//                   sx={{
//                     position: 'absolute',
//                     top: -4,
//                     right: -4,
//                     bgcolor: '#ff4444',
//                     color: 'white',
//                     width: 18,
//                     height: 18,
//                     fontSize: '10px',
//                     '&:hover': {
//                       bgcolor: '#cc0000',
//                     }
//                   }}
//                   onClick={(e) => {
//                     e.stopPropagation();
//                     const newPreviews = [...imagePreviews];
//                     const newFiles = [...propertyImages];
                    
//                     URL.revokeObjectURL(preview);
                    
//                     newPreviews.splice(index, 1);
//                     newFiles.splice(index, 1);
                    
//                     setImagePreviews(newPreviews);
//                     setPropertyImages(newFiles);
//                   }}
//                 >
//                   ×
//                 </IconButton>
//               </Box>
//             ))}
//           </Box>
//         </Box>
//       )}
//     </Box>
//   );

//   // Render form based on property type
//   const renderForm = () => {
//     const selectedType = getSelectedPropertyType();
//     const isPlot = selectedType?.id === 'plot';
//     const isAgricultureLand = selectedType?.id === 'agriculture-land';

//     return (
//       <Box>
//         {/* Property Type Dropdown */}
//         <Box sx={{ mb: 3 }}>
//           <Typography sx={{
//             fontSize: '13px',
//             fontWeight: 500,
//             color: '#333',
//             fontFamily: 'Outfit',
//             mb: 1
//           }}>
//             Property Type <span style={{ color: '#d32f2f' }}>*</span>
//           </Typography>
//           <FormControl fullWidth size="small">
//             <Select
//               value={selectedPropertyType}
//               onChange={(e) => handlePropertyTypeSelect(e.target.value)}
//               displayEmpty
//               sx={{
//                 borderRadius: 1.5,
//                 fontFamily: 'Outfit',
//                 fontSize: '13px',
//               }}
//               renderValue={(selected) => {
//                 const propertyTypes = isCommercial ? commercialPropertyTypes : residentialPropertyTypes;
//                 const selectedTypeObj = propertyTypes.find(type => type.id === selected);
                
//                 if (!selectedTypeObj) {
//                   return <em style={{ color: '#999' }}>Select Property Type</em>;
//                 }
                
//                 return (
//                   <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                     <Box
//                       component="img"
//                       src={selectedTypeObj.icon}
//                       alt={selectedTypeObj.name}
//                       sx={{ width: 20, height: 20, objectFit: 'contain' }}
//                     />
//                     <Typography sx={{ fontFamily: 'Outfit', fontSize: '13px' }}>
//                       {selectedTypeObj.name}
//                     </Typography>
//                   </Box>
//                 );
//               }}
//             >
//               {(isCommercial ? commercialPropertyTypes : residentialPropertyTypes).map((type) => (
//                 <MenuItem key={type.id} value={type.id}>
//                   <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                     <Box
//                       component="img"
//                       src={type.icon}
//                       alt={type.name}
//                       sx={{ width: 20, height: 20, objectFit: 'contain' }}
//                     />
//                     {type.name}
//                                   </Box>
//                 </MenuItem>
//               ))}
//             </Select>
//           </FormControl>
//         </Box>

//         {/* Image Upload Section */}
//         {renderImageUploadSection()}

//         {/* Building Name & Area Name - Side by Side */}
//         <Grid container spacing={2} sx={{ mb: 3 }}>
//           <Grid item xs={12} sm={6}>
//             <Typography sx={{
//               fontSize: '13px',
//               fontWeight: 500,
//               color: '#333',
//               fontFamily: 'Outfit',
//               mb: 1
//             }}>
//               Building/Project Name <span style={{ color: '#d32f2f' }}>*</span>
//             </Typography>
//             <TextField
//               id="buildingName"
//               fullWidth
//               size="small"
//               placeholder="Enter building name"
//               value={buildingName}
//               onChange={(e) => {
//                 setBuildingName(e.target.value);
//                 setErrors(prev => ({...prev, buildingName: validateAlphanumeric(e.target.value, "Building name")}));
//               }}
//               error={!!errors.buildingName}
//               helperText={errors.buildingName}
//               sx={{
//                 '& .MuiOutlinedInput-root': {
//                   borderRadius: 1.5,
//                   fontFamily: 'Outfit',
//                   fontSize: '13px',
//                 },
//               }}
//             />
//           </Grid>

//           <Grid item xs={12} sm={6}>
//             <Typography sx={{
//               fontSize: '13px',
//               fontWeight: 500,
//               color: '#333',
//               fontFamily: 'Outfit',
//               mb: 1
//             }}>
//               Area Name <span style={{ color: '#d32f2f' }}>*</span>
//             </Typography>
//             <ClickAwayListener onClickAway={handleAreaClickAway}>
//               <Box sx={{ position: 'relative' }}>
//                 <TextField
//                   id="areaName"
//                   fullWidth
//                   size="small"
//                   placeholder="Enter area name"
//                   value={areaName}
//                   onChange={handleAreaNameChange}
//                   error={!!errors.areaName}
//                   helperText={errors.areaName}
//                   sx={{
//                     '& .MuiOutlinedInput-root': {
//                       borderRadius: 1.5,
//                       fontFamily: 'Outfit',
//                       fontSize: '13px',
//                     },
//                   }}
//                 />
//                 {showAreaSuggestions && areaSuggestions.length > 0 && (
//                   <Popper
//                     open={showAreaSuggestions}
//                     anchorEl={areaAnchorEl}
//                     placement="bottom-start"
//                     transition
//                     style={{
//                       width: areaAnchorEl ? areaAnchorEl.clientWidth : 'auto',
//                       zIndex: 1300
//                     }}
//                   >
//                     {({ TransitionProps }) => (
//                       <Grow {...TransitionProps} timeout={200}>
//                         <Paper
//                           elevation={3}
//                           sx={{
//                             maxHeight: 200,
//                             overflow: 'auto',
//                             mt: 0.5,
//                             border: '1px solid #e0e0e0',
//                             borderRadius: 1
//                           }}
//                         >
//                           <List dense>
//                             {areaSuggestions.map((area, index) => (
//                               <ListItem
//                                 key={index}
//                                 button
//                                 onClick={() => handleSelectArea(area)}
//                                 sx={{
//                                   py: 0.8,
//                                   '&:hover': {
//                                     backgroundColor: '#f5f5f5'
//                                   }
//                                 }}
//                               >
//                                 <ListItemText
//                                   primary={area.area}
//                                   primaryTypographyProps={{
//                                     fontFamily: 'Outfit',
//                                     fontWeight: 500,
//                                     fontSize: '13px'
//                                   }}
//                                 />
//                               </ListItem>
//                             ))}
//                           </List>
//                         </Paper>
//                       </Grow>
//                     )}
//                   </Popper>
//                 )}
//               </Box>
//             </ClickAwayListener>
//           </Grid>
//         </Grid>

//         {/* Complete Address */}
//         <Box sx={{ mb: 3 }}>
//           <Typography sx={{
//             fontSize: '13px',
//             fontWeight: 500,
//             color: '#333',
//             fontFamily: 'Outfit',
//             mb: 1
//           }}>
//             Complete Address <span style={{ color: '#d32f2f' }}>*</span>
//           </Typography>
//           <TextField
//             id="completeAddress"
//             fullWidth
//             size="small"
//             multiline
//             rows={2}
//             placeholder="Enter complete address"
//             value={completeAddress}
//             onChange={(e) => {
//               setCompleteAddress(e.target.value);
//               setErrors(prev => ({...prev, completeAddress: validateCompleteAddress(e.target.value)}));
//             }}
//             error={!!errors.completeAddress}
//             helperText={errors.completeAddress}
//             sx={{
//               '& .MuiOutlinedInput-root': {
//                 borderRadius: 1.5,
//                 fontFamily: 'Outfit',
//                 fontSize: '13px',
//               },
//             }}
//           />
//         </Box>

//         {/* Conditional Fields for Plot/Agriculture Land */}
//         {(isPlot || isAgricultureLand) && (
//           <>
//             {/* Description & Content - Side by Side */}
//             {isPlot && (
//               <Grid container spacing={2} sx={{ mb: 3 }}>
//                 <Grid item xs={12} sm={6}>
//                   <Typography sx={{
//                     fontSize: '13px',
//                     fontWeight: 500,
//                     color: '#333',
//                     fontFamily: 'Outfit',
//                     mb: 1
//                   }}>
//                     Description <span style={{ color: '#d32f2f' }}>*</span>
//                   </Typography>
//                   <TextField
//                     id="propertyDescription"
//                     fullWidth
//                     size="small"
//                     multiline
//                     rows={3}
//                     placeholder="Short description"
//                     value={propertyDescription}
//                     onChange={(e) => {
//                       setPropertyDescription(e.target.value);
//                       setErrors(prev => ({...prev, propertyDescription: validateName(e.target.value)}));
//                     }}
//                     error={!!errors.propertyDescription}
//                     helperText={errors.propertyDescription}
//                     sx={{
//                       '& .MuiOutlinedInput-root': {
//                         borderRadius: 1.5,
//                         fontFamily: 'Outfit',
//                         fontSize: '13px',
//                       },
//                     }}
//                   />
//                 </Grid>

//                 <Grid item xs={12} sm={6}>
//                   <Typography sx={{
//                     fontSize: '13px',
//                     fontWeight: 500,
//                     color: '#333',
//                     fontFamily: 'Outfit',
//                     mb: 1
//                   }}>
//                     Content <span style={{ color: '#d32f2f' }}>*</span>
//                   </Typography>
//                   <TextField
//                     id="propertyContent"
//                     fullWidth
//                     size="small"
//                     multiline
//                     rows={3}
//                     placeholder="Content"
//                     value={propertyContent}
//                     onChange={(e) => {
//                       setPropertyContent(e.target.value);
//                       setErrors(prev => ({...prev, propertyContent: validateName(e.target.value)}));
//                     }}
//                     error={!!errors.propertyContent}
//                     helperText={errors.propertyContent}
//                     sx={{
//                       '& .MuiOutlinedInput-root': {
//                         borderRadius: 1.5,
//                         fontFamily: 'Outfit',
//                         fontSize: '13px',
//                       },
//                     }}
//                   />
//                 </Grid>
//               </Grid>
//             )}

//             {/* Property Size & Length/Width */}
//             <Grid container spacing={2} sx={{ mb: 3 }}>
//               <Grid item xs={12} sm={4}>
//                 <Typography sx={{
//                   fontSize: '13px',
//                   fontWeight: 500,
//                   color: '#333',
//                   fontFamily: 'Outfit',
//                   mb: 1
//                 }}>
//                   Property Size <span style={{ color: '#d32f2f' }}>*</span>
//                 </Typography>
//                 <TextField
//                   id="propertySize"
//                   fullWidth
//                   size="small"
//                   placeholder="Enter size"
//                   value={propertySize}
//                   onChange={(e) => {
//                     const value = e.target.value.replace(/[^0-9]/g, '');
//                     setPropertySize(value);
//                     setErrors(prev => ({...prev, propertySize: validateNumber(value, "Property size")}));
//                   }}
//                   error={!!errors.propertySize}
//                   helperText={errors.propertySize}
//                   sx={{
//                     '& .MuiOutlinedInput-root': {
//                       borderRadius: 1.5,
//                       fontFamily: 'Outfit',
//                       fontSize: '13px',
//                     },
//                   }}
//                 />
//               </Grid>

//               <Grid item xs={12} sm={2}>
//                 <Typography sx={{
//                   fontSize: '13px',
//                   fontWeight: 500,
//                   color: '#333',
//                   fontFamily: 'Outfit',
//                   mb: 1
//                 }}>
//                   Unit
//                 </Typography>
//                 <FormControl fullWidth size="small">
//                   <Select
//                     value={selectedUnit}
//                     onChange={(e) => setSelectedUnit(e.target.value)}
//                     sx={{
//                       borderRadius: 1.5,
//                       fontFamily: 'Outfit',
//                       fontSize: '13px',
//                     }}
//                   >
//                     <MenuItem value="sq.ft">Sq. ft</MenuItem>
//                     <MenuItem value="sqm">Sq. m</MenuItem>
//                     <MenuItem value="acres">Acres</MenuItem>
//                     <MenuItem value="sq.yards">Sq. yards</MenuItem>
//                   </Select>
//                 </FormControl>
//               </Grid>

//               <Grid item xs={6} sm={3}>
//                 <Typography sx={{
//                   fontSize: '13px',
//                   fontWeight: 500,
//                   color: '#333',
//                   fontFamily: 'Outfit',
//                   mb: 1
//                 }}>
//                   Length <span style={{ color: '#d32f2f' }}>*</span>
//                 </Typography>
//                 <TextField
//                   id="propertyLength"
//                   fullWidth
//                   size="small"
//                   placeholder="Length"
//                   value={propertyLength}
//                   onChange={(e) => {
//                     const value = e.target.value.replace(/[^0-9]/g, '');
//                     setPropertyLength(value);
//                     setErrors(prev => ({...prev, propertyLength: validateNumber(value, "Length")}));
//                   }}
//                   error={!!errors.propertyLength}
//                   helperText={errors.propertyLength}
//                   sx={{
//                     '& .MuiOutlinedInput-root': {
//                       borderRadius: 1.5,
//                       fontFamily: 'Outfit',
//                       fontSize: '13px',
//                     },
//                   }}
//                 />
//               </Grid>

//               <Grid item xs={6} sm={3}>
//                 <Typography sx={{
//                   fontSize: '13px',
//                   fontWeight: 500,
//                   color: '#333',
//                   fontFamily: 'Outfit',
//                   mb: 1
//                 }}>
//                   Width <span style={{ color: '#d32f2f' }}>*</span>
//                 </Typography>
//                 <TextField
//                   id="propertyWidth"
//                   fullWidth
//                   size="small"
//                   placeholder="Width"
//                   value={propertyWidth}
//                   onChange={(e) => {
//                     const value = e.target.value.replace(/[^0-9]/g, '');
//                     setPropertyWidth(value);
//                     setErrors(prev => ({...prev, propertyWidth: validateNumber(value, "Width")}));
//                   }}
//                   error={!!errors.propertyWidth}
//                   helperText={errors.propertyWidth}
//                   sx={{
//                     '& .MuiOutlinedInput-root': {
//                       borderRadius: 1.5,
//                       fontFamily: 'Outfit',
//                       fontSize: '13px',
//                     },
//                   }}
//                 />
//               </Grid>
//             </Grid>
//           </>
//         )}

//         {/* Fields for Apartment/Independent House/Duplex */}
//         {!isPlot && !isAgricultureLand && !isCommercial && (
//           <>
//             {/* Contact Information */}
//             <Box sx={{ mb: 3 }}>
//               <Typography sx={{
//                 fontSize: '14px',
//                 fontWeight: 600,
//                 color: '#333',
//                 fontFamily: 'Outfit',
//                 mb: 2
//               }}>
//                 Contact Information <span style={{ color: '#d32f2f' }}>*</span>
//               </Typography>
              
//               <Grid container spacing={2}>
//                 <Grid item xs={12} sm={4}>
//                   <Typography sx={{
//                     fontSize: '12px',
//                     fontWeight: 500,
//                     color: '#666',
//                     fontFamily: 'Outfit',
//                     mb: 0.5
//                   }}>
//                     Owner Name
//                   </Typography>
//                   <TextField
//                     id="ownerName"
//                     fullWidth
//                     size="small"
//                     placeholder="Enter owner name"
//                     value={ownerName}
//                     onChange={(e) => {
//                       setOwnerName(e.target.value);
//                       if (e.target.value !== 'N/A') {
//                         setErrors(prev => ({...prev, ownerName: validateName(e.target.value)}));
//                       }
//                     }}
//                     disabled={profileData?.full_name && profileData.full_name !== '' && profileData.full_name !== 'N/A'}
//                     error={!!errors.ownerName}
//                     helperText={errors.ownerName}
//                     sx={{
//                       '& .MuiOutlinedInput-root': {
//                         borderRadius: 1.5,
//                         fontFamily: 'Outfit',
//                         fontSize: '13px',
//                         backgroundColor: (profileData?.full_name && profileData.full_name !== '' && profileData.full_name !== 'N/A') ? '#f5f5f5' : 'white'
//                       },
//                     }}
//                   />
//                 </Grid>

//                 <Grid item xs={12} sm={4}>
//                   <Typography sx={{
//                     fontSize: '12px',
//                     fontWeight: 500,
//                     color: '#666',
//                     fontFamily: 'Outfit',
//                     mb: 0.5
//                   }}>
//                     Contact Number
//                   </Typography>
//                   <TextField
//                     id="contactNumber"
//                     fullWidth
//                     size="small"
//                     type="tel"
//                     placeholder="Enter contact number"
//                     value={contactNumber}
//                     onChange={(e) => {
//                       const value = e.target.value;
//                       if (value === 'N/A' || value === '') {
//                         setContactNumber(value);
//                       } else {
//                         const numericValue = value.replace(/\D/g, '').slice(0, 10);
//                         setContactNumber(numericValue);
//                         if (numericValue !== 'N/A') {
//                           setErrors(prev => ({...prev, contactNumber: validatePhone(numericValue)}));
//                         }
//                       }
//                     }}
//                     disabled={profileData?.contact_number && profileData.contact_number !== '' && profileData.contact_number !== 'N/A'}
//                     error={!!errors.contactNumber}
//                     helperText={errors.contactNumber}
//                     inputProps={{ maxLength: 10 }}
//                     sx={{
//                       '& .MuiOutlinedInput-root': {
//                         borderRadius: 1.5,
//                         fontFamily: 'Outfit',
//                         fontSize: '13px',
//                         backgroundColor: (profileData?.contact_number && profileData.contact_number !== '' && profileData.contact_number !== 'N/A') ? '#f5f5f5' : 'white'
//                       },
//                     }}
//                   />
//                 </Grid>

//                 <Grid item xs={12} sm={4}>
//                   <Typography sx={{
//                     fontSize: '12px',
//                     fontWeight: 500,
//                     color: '#666',
//                     fontFamily: 'Outfit',
//                     mb: 0.5
//                   }}>
//                     Email Address
//                   </Typography>
//                   <TextField
//                     id="emailAddress"
//                     fullWidth
//                     size="small"
//                     type="email"
//                     placeholder="Enter email address"
//                     value={emailAddress}
//                     onChange={(e) => {
//                       setEmailAddress(e.target.value);
//                       if (e.target.value !== 'N/A') {
//                         setErrors(prev => ({...prev, emailAddress: validateEmail(e.target.value)}));
//                       }
//                     }}
//                     disabled={profileData?.email_id && profileData.email_id !== '' && profileData.email_id !== 'N/A'}
//                     error={!!errors.emailAddress}
//                     helperText={errors.emailAddress}
//                     sx={{
//                       '& .MuiOutlinedInput-root': {
//                         borderRadius: 1.5,
//                         fontFamily: 'Outfit',
//                         fontSize: '13px',
//                         backgroundColor: (profileData?.email_id && profileData.email_id !== '' && profileData.email_id !== 'N/A') ? '#f5f5f5' : 'white'
//                       },
//                     }}
//                   />
//                 </Grid>
//               </Grid>
//             </Box>

//             {/* YouTube Link */}
//             <Box sx={{ mb: 3 }}>
//               <Typography sx={{
//                 fontSize: '13px',
//                 fontWeight: 500,
//                 color: '#333',
//                 fontFamily: 'Outfit',
//                 mb: 1
//               }}>
//                 YouTube Link (Optional)
//               </Typography>
//               <TextField
//                 id="youtubeLink"
//                 fullWidth
//                 size="small"
//                 type="url"
//                 placeholder="Paste YouTube link"
//                 value={youtubeLink}
//                 onChange={(e) => {
//                   setYoutubeLink(e.target.value);
//                   if (e.target.value) {
//                     setErrors(prev => ({...prev, youtubeLink: validateYouTubeLink(e.target.value)}));
//                   } else {
//                     setErrors(prev => ({...prev, youtubeLink: ''}));
//                   }
//                 }}
//                 error={!!errors.youtubeLink}
//                 helperText={errors.youtubeLink}
//                 InputProps={{
//                   startAdornment: (
//                     <InputAdornment position="start">
//                       <Box
//                         component="img"
//                         src={youtubeIcon}
//                         alt="YouTube"
//                         sx={{ width: 24, height: 18 }}
//                       />
//                     </InputAdornment>
//                   ),
//                 }}
//                 sx={{
//                   '& .MuiOutlinedInput-root': {
//                     borderRadius: 1.5,
//                     fontFamily: 'Outfit',
//                     fontSize: '13px',
//                   },
//                 }}
//               />
//             </Box>

//             {/* BHK & Furnish Type - Side by Side */}
//             <Grid container spacing={2} sx={{ mb: 3 }}>
//               <Grid item xs={12} sm={6}>
//                 <Typography sx={{
//                   fontSize: '13px',
//                   fontWeight: 500,
//                   color: '#333',
//                   fontFamily: 'Outfit',
//                   mb: 1
//                 }}>
//                   BHK <span style={{ color: '#d32f2f' }}>*</span>
//                 </Typography>
//                 <FormControl fullWidth size="small" error={!!errors.bhk}>
//                   <Select
//                     value={selectedBHK}
//                     onChange={(e) => {
//                       setSelectedBHK(e.target.value);
//                       setErrors({...errors, bhk: ''});
//                     }}
//                     displayEmpty
//                     sx={{
//                       borderRadius: 1.5,
//                       fontFamily: 'Outfit',
//                       fontSize: '13px',
//                     }}
//                   >
//                     <MenuItem value="" disabled>
//                       <em>Select BHK</em>
//                     </MenuItem>
//                     {bhkOptions.map((option) => (
//                       <MenuItem key={option.id} value={option.id}>
//                         {option.label}
//                       </MenuItem>
//                     ))}
//                   </Select>
//                   {errors.bhk && (
//                     <FormHelperText sx={{ fontSize: '11px' }}>{errors.bhk}</FormHelperText>
//                   )}
//                 </FormControl>
//               </Grid>

//               <Grid item xs={12} sm={6}>
//                 <Typography sx={{
//                   fontSize: '13px',
//                   fontWeight: 500,
//                   color: '#333',
//                   fontFamily: 'Outfit',
//                   mb: 1
//                 }}>
//                   Furnish Type <span style={{ color: '#d32f2f' }}>*</span>
//                 </Typography>
//                 <FormControl fullWidth size="small" error={!!errors.furnish}>
//                   <Select
//                     value={selectedFurnish}
//                     onChange={(e) => {
//                       setSelectedFurnish(e.target.value);
//                       setErrors({...errors, furnish: ''});
//                     }}
//                     displayEmpty
//                     sx={{
//                       borderRadius: 1.5,
//                       fontFamily: 'Outfit',
//                       fontSize: '13px',
//                     }}
//                   >
//                     <MenuItem value="" disabled>
//                       <em>Select Furnish Type</em>
//                     </MenuItem>
//                     {furnishTypes.map((type) => (
//                       <MenuItem key={type.id} value={type.id}>
//                         {type.label}
//                       </MenuItem>
//                     ))}
//                   </Select>
//                   {errors.furnish && (
//                     <FormHelperText sx={{ fontSize: '11px' }}>{errors.furnish}</FormHelperText>
//                   )}
//                 </FormControl>
//               </Grid>
//             </Grid>

//             {/* Carpet Area, Built-up Area, UDS - For Apartment/Independent House/Duplex */}
//             {(selectedType?.id === 'apartment' || selectedType?.id === 'independent-house' || selectedType?.id === 'duplex') && (
//               <>
//                 <Grid container spacing={2} sx={{ mb: 3 }}>
//                   <Grid item xs={12} sm={4}>
//                     <Typography sx={{
//                       fontSize: '13px',
//                       fontWeight: 500,
//                       color: '#333',
//                       fontFamily: 'Outfit',
//                       mb: 1
//                     }}>
//                       Carpet Area
//                     </Typography>
//                     <TextField
//                       id="carpetArea"
//                       fullWidth
//                       size="small"
//                       placeholder="Enter carpet area"
//                       value={carpetArea}
//                       onChange={(e) => {
//                         const value = e.target.value.replace(/[^0-9]/g, '');
//                         setCarpetArea(value);
//                       }}
//                       sx={{
//                         '& .MuiOutlinedInput-root': {
//                           borderRadius: 1.5,
//                           fontFamily: 'Outfit',
//                           fontSize: '13px',
//                         },
//                       }}
//                     />
//                   </Grid>

//                   <Grid item xs={12} sm={4}>
//                     <Typography sx={{
//                       fontSize: '13px',
//                       fontWeight: 500,
//                       color: '#333',
//                       fontFamily: 'Outfit',
//                       mb: 1
//                     }}>
//                       Built-up Area
//                     </Typography>
//                     <TextField
//                       id="builtUpArea"
//                       fullWidth
//                       size="small"
//                       placeholder="Enter built-up area"
//                       value={builtUpArea}
//                       onChange={(e) => {
//                         const value = e.target.value.replace(/[^0-9]/g, '');
//                         setBuiltUpArea(value);
//                       }}
//                       sx={{
//                         '& .MuiOutlinedInput-root': {
//                           borderRadius: 1.5,
//                           fontFamily: 'Outfit',
//                           fontSize: '13px',
//                         },
//                       }}
//                     />
//                   </Grid>

//                   <Grid item xs={12} sm={4}>
//                     <Typography sx={{
//                       fontSize: '13px',
//                       fontWeight: 500,
//                       color: '#333',
//                       fontFamily: 'Outfit',
//                       mb: 1
//                     }}>
//                       UDS {selectedType?.id === 'independent-house' && <span style={{ color: '#d32f2f' }}>*</span>}
//                     </Typography>
//                     <TextField
//                       id="udsArea"
//                       fullWidth
//                       size="small"
//                       placeholder={selectedType?.id === 'independent-house' ? "Required" : "Optional"}
//                       value={udsArea}
//                       onChange={(e) => {
//                         const value = e.target.value.replace(/[^0-9]/g, '');
//                         setUdsArea(value);
//                         setErrors(prev => ({
//                           ...prev,
//                           udsArea: validateUdsArea(value, selectedType?.id)
//                         }));
//                       }}
//                       error={!!errors.udsArea}
//                       helperText={errors.udsArea}
//                       sx={{
//                         '& .MuiOutlinedInput-root': {
//                           borderRadius: 1.5,
//                           fontFamily: 'Outfit',
//                           fontSize: '13px',
//                         },
//                       }}
//                     />
//                   </Grid>
//                 </Grid>
//               </>
//             )}

//             {/* Property Size - For non-apartment types */}
//             {selectedType?.id !== 'apartment' && (
//               <Grid container spacing={2} sx={{ mb: 3 }}>
//                 <Grid item xs={12} sm={6}>
//                   <Typography sx={{
//                     fontSize: '13px',
//                     fontWeight: 500,
//                     color: '#333',
//                     fontFamily: 'Outfit',
//                     mb: 1
//                   }}>
//                     Property Size <span style={{ color: '#d32f2f' }}>*</span>
//                   </Typography>
//                   <TextField
//                     id="propertySize"
//                     fullWidth
//                     size="small"
//                     placeholder="Enter property size"
//                     value={propertySize}
//                     onChange={(e) => {
//                       const value = e.target.value.replace(/[^0-9]/g, '');
//                       setPropertySize(value);
//                       setErrors(prev => ({...prev, propertySize: validateNumber(value, "Property size")}));
//                     }}
//                     error={!!errors.propertySize}
//                     helperText={errors.propertySize}
//                     sx={{
//                       '& .MuiOutlinedInput-root': {
//                         borderRadius: 1.5,
//                         fontFamily: 'Outfit',
//                         fontSize: '13px',
//                       },
//                     }}
//                   />
//                 </Grid>

//                 <Grid item xs={12} sm={6}>
//                   <Typography sx={{
//                     fontSize: '13px',
//                     fontWeight: 500,
//                     color: '#333',
//                     fontFamily: 'Outfit',
//                     mb: 1
//                   }}>
//                     Unit
//                   </Typography>
//                   <FormControl fullWidth size="small">
//                     <Select
//                       value={selectedUnit}
//                       onChange={(e) => setSelectedUnit(e.target.value)}
//                       sx={{
//                         borderRadius: 1.5,
//                         fontFamily: 'Outfit',
//                         fontSize: '13px',
//                       }}
//                     >
//                       <MenuItem value="sq.ft">Sq. ft</MenuItem>
//                       <MenuItem value="sqm">Sq. m</MenuItem>
//                       <MenuItem value="acres">Acres</MenuItem>
//                       <MenuItem value="sq.yards">Sq. yards</MenuItem>
//                     </Select>
//                   </FormControl>
//                 </Grid>
//               </Grid>
//             )}

//             {/* Add Amenities Button */}
//             <Box sx={{ mb: 3 }}>
//               <Button
//                 onClick={handleOpenAmenitiesDialog}
//                 sx={{
//                   fontSize: '13px',
//                   fontWeight: 500,
//                   color: '#1976d2',
//                   fontFamily: 'Outfit',
//                   textTransform: 'none',
//                   p: 0,
//                   '&:hover': {
//                     backgroundColor: 'transparent',
//                     textDecoration: 'underline'
//                   }
//                 }}
//               >
//                 + Add Amenities / Key features
//               </Button>
//               {selectedAmenities && (
//                 <SelectedAmenitiesDisplay selectedAmenities={selectedAmenities} />
//               )}
//             </Box>
//           </>
//         )}

//         {/* Commercial Office Fields */}
//         {isCommercial && (
//           <>
//             {/* Hub, Ownership, Status - 3 columns */}
//             <Grid container spacing={2} sx={{ mb: 3 }}>
//               <Grid item xs={12} sm={4}>
//                 <Typography sx={{
//                   fontSize: '13px',
//                   fontWeight: 500,
//                   color: '#333',
//                   fontFamily: 'Outfit',
//                   mb: 1
//                 }}>
//                   Hub <span style={{ color: '#d32f2f' }}>*</span>
//                 </Typography>
//                 <FormControl fullWidth size="small">
//                   <Select
//                     value={selectedHub}
//                     onChange={(e) => setSelectedHub(e.target.value)}
//                     displayEmpty
//                     sx={{
//                       borderRadius: 1.5,
//                       fontFamily: 'Outfit',
//                       fontSize: '13px',
//                     }}
//                   >
//                     <MenuItem value="" disabled>
//                       <em>Select Hub</em>
//                     </MenuItem>
//                     {hubs.map((hub) => (
//                       <MenuItem key={hub} value={hub}>
//                         {hub}
//                       </MenuItem>
//                     ))}
//                   </Select>
//                 </FormControl>
//               </Grid>

//               <Grid item xs={12} sm={4}>
//                 <Typography sx={{
//                   fontSize: '13px',
//                   fontWeight: 500,
//                   color: '#333',
//                   fontFamily: 'Outfit',
//                   mb: 1
//                 }}>
//                   Ownership <span style={{ color: '#d32f2f' }}>*</span>
//                 </Typography>
//                 <FormControl fullWidth size="small">
//                   <Select
//                     value={selectedOwnership}
//                     onChange={(e) => setSelectedOwnership(e.target.value)}
//                     displayEmpty
//                     sx={{
//                       borderRadius: 1.5,
//                       fontFamily: 'Outfit',
//                       fontSize: '13px',
//                     }}
//                   >
//                     <MenuItem value="" disabled>
//                       <em>Select Ownership</em>
//                     </MenuItem>
//                     {ownerships.map((own) => (
//                       <MenuItem key={own} value={own}>
//                         {own}
//                       </MenuItem>
//                     ))}
//                   </Select>
//                 </FormControl>
//               </Grid>

//               <Grid item xs={12} sm={4}>
//                 <Typography sx={{
//                   fontSize: '13px',
//                   fontWeight: 500,
//                   color: '#333',
//                   fontFamily: 'Outfit',
//                   mb: 1
//                 }}>
//                   Status <span style={{ color: '#d32f2f' }}>*</span>
//                 </Typography>
//                 <FormControl fullWidth size="small">
//                   <Select
//                     value={selectedStatus}
//                     onChange={(e) => setSelectedStatus(e.target.value)}
//                     displayEmpty
//                     sx={{
//                       borderRadius: 1.5,
//                       fontFamily: 'Outfit',
//                       fontSize: '13px',
//                     }}
//                   >
//                     <MenuItem value="" disabled>
//                       <em>Select Status</em>
//                     </MenuItem>
//                     {statuses.map((status) => (
//                       <MenuItem key={status} value={status}>
//                         {status}
//                       </MenuItem>
//                     ))}
//                   </Select>
//                 </FormControl>
//               </Grid>
//             </Grid>

//             {/* Total Floors & Select Floor */}
//             <Grid container spacing={2} sx={{ mb: 3 }}>
//               <Grid item xs={12} sm={6}>
//                 <Typography sx={{
//                   fontSize: '13px',
//                   fontWeight: 500,
//                   color: '#333',
//                   fontFamily: 'Outfit',
//                   mb: 1
//                 }}>
//                   Total Floors <span style={{ color: '#d32f2f' }}>*</span>
//                 </Typography>
//                 <TextField
//                   id="totalFloors"
//                   fullWidth
//                   size="small"
//                   placeholder="Enter total floors"
//                   value={totalFloors}
//                   onChange={(e) => {
//                     const value = e.target.value.replace(/[^0-9]/g, '');
//                     setTotalFloors(value);
//                     setErrors(prev => ({...prev, totalFloors: validateNumber(value, "Total floors", 1, 100)}));
//                   }}
//                   error={!!errors.totalFloors}
//                   helperText={errors.totalFloors}
//                   sx={{
//                     '& .MuiOutlinedInput-root': {
//                       borderRadius: 1.5,
//                       fontFamily: 'Outfit',
//                       fontSize: '13px',
//                     },
//                   }}
//                 />
//               </Grid>

//               <Grid item xs={12} sm={6}>
//                 <Typography sx={{
//                   fontSize: '13px',
//                   fontWeight: 500,
//                   color: '#333',
//                   fontFamily: 'Outfit',
//                   mb: 1
//                 }}>
//                   Select Floor <span style={{ color: '#d32f2f' }}>*</span>
//                 </Typography>
//                 <FormControl fullWidth size="small" error={!!errors.selectedFloor}>
//                   <Select
//                     id="selectedFloor"
//                     value={selectedFloor}
//                     onChange={(e) => {
//                       setSelectedFloor(e.target.value);
//                       setErrors({...errors, selectedFloor: ''});
//                     }}
//                     displayEmpty
//                     sx={{
//                       borderRadius: 1.5,
//                       fontFamily: 'Outfit',
//                       fontSize: '13px',
//                     }}
//                   >
//                     <MenuItem value="" disabled>Select Floor</MenuItem>
//                     {[...Array(20)].map((_, i) => (
//                       <MenuItem key={i + 1} value={`${i + 1}${i === 0 ? 'st' : i === 1 ? 'nd' : i === 2 ? 'rd' : 'th'} Floor`}>
//                         {i + 1}{i === 0 ? 'st' : i === 1 ? 'nd' : i === 2 ? 'rd' : 'th'} Floor
//                       </MenuItem>
//                     ))}
//                   </Select>
//                   {errors.selectedFloor && (
//                     <FormHelperText sx={{ fontSize: '11px' }}>{errors.selectedFloor}</FormHelperText>
//                   )}
//                 </FormControl>
//               </Grid>
//             </Grid>
//           </>
//         )}
//       </Box>
//     );
//   };

//   return (
//     <Container maxWidth="lg" sx={{ py: { xs: 2, md: 3 } }}>
//       <Box
//         sx={{
//           display: 'flex',
//           flexDirection: { xs: 'column', md: 'row' },
//           gap: { xs: 2, md: 3 },
//           justifyContent: 'center',
//           maxWidth: '1050px',
//           margin: '0 auto',
//         }}
//       >
//         {/* Left Sidebar - Stepper */}
//         <Paper
//           elevation={0}
//           sx={{
//             width: { xs: '100%', md: '280px' },
//             p: { xs: 2.5, md: 3 },
//             backgroundColor: '#f8f9fa',
//             borderRadius: 2,
//             border: '1px solid #e0e0e0',
//             display: 'flex',
//             flexDirection: 'column',
//             alignItems: { xs: 'stretch', md: 'flex-start' },
//             justifyContent: { xs: 'flex-start', md: 'center' },
//             minHeight: { md: '400px' },
//             position: { md: 'sticky' },
//             top: { md: 20 },
//           }}
//         >
//           <Typography
//             variant="h6"
//             sx={{
//               fontFamily: 'Outfit',
//               fontWeight: 600,
//               mb: { xs: 2.5, md: 4 },
//               fontSize: { xs: '16px', md: '18px' },
//               textAlign: 'left',
//               width: '100%',
//             }}
//           >
//             Post your property
//           </Typography>

//           {/* Desktop Stepper - Vertical */}
//           {!isMobile && (
//             <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
//               {['Basic Details', 'Property Details', 'Price Details'].map((label, index) => (
//                 <Box key={label}>
//                   <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
//                     <CustomStepIcon
//                       active={index === 1}
//                       completed={index < 1}
//                       isMobile={false}
//                     />
//                     <Typography
//                       sx={{
//                         fontFamily: 'Outfit',
//                         fontSize: '14px',
//                         fontWeight: index === 1 ? 600 : 400,
//                         color:
//                           index === 1
//                             ? '#1976d2'
//                             : index < 1
//                             ? '#4caf50'
//                             : '#666',
//                       }}
//                     >
//                       {label}
//                     </Typography>
//                   </Box>
//                   {index < 2 && <CustomStepConnector />}
//                 </Box>
//               ))}
//             </Box>
//           )}

//           {/* Mobile Stepper - Horizontal */}
//           {isMobile && (
//             <Box
//               sx={{
//                 display: 'flex',
//                 alignItems: 'flex-start',
//                 justifyContent: 'space-between',
//                 width: '100%',
//               }}
//             >
//               {['Basic Details', 'Property Details', 'Price Details'].map((label, index) => (
//                 <React.Fragment key={label}>
//                   <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
//                     <CustomStepIcon
//                       active={index === 1}
//                       completed={index < 1}
//                       isMobile={true}
//                     />
//                     <Typography
//                       sx={{
//                         fontFamily: 'Outfit',
//                         fontSize: '11px',
//                         fontWeight: index === 1 ? 600 : 400,
//                         color:
//                           index === 1
//                             ? '#1976d2'
//                             : index < 1
//                             ? '#4caf50'
//                             : '#666',
//                         mt: 0.8,
//                         textAlign: 'center',
//                         maxWidth: '70px',
//                         lineHeight: 1.2,
//                       }}
//                     >
//                       {label}
//                     </Typography>
//                   </Box>
//                   {index < 2 && (
//                     <Box sx={{ display: 'flex', alignItems: 'center', pt: '0px', pb: '28px' }}>
//                       <CustomStepConnectorHorizontal />
//                     </Box>
//                   )}
//                 </React.Fragment>
//               ))}
//             </Box>
//           )}
//         </Paper>

//         {/* Main Content Area */}
//         <Paper
//           elevation={0}
//           sx={{
//             flex: 1,
//             maxWidth: { xs: '100%', md: '700px' },
//             p: { xs: 2.5, sm: 3, md: 3.5 },
//             backgroundColor: '#ffffff',
//             borderRadius: 2,
//             border: '1px solid #e0e0e0',
//           }}
//         >
//           <Typography
//             variant="h5"
//             sx={{
//               fontFamily: 'Outfit',
//               fontWeight: 600,
//               mb: 3,
//               fontSize: { xs: '18px', md: '22px' },
//             }}
//           >
//             Add Property Details
//           </Typography>

//           {/* Render Form */}
//           {renderForm()}

//           {/* Navigation Buttons */}
//           <Box
//             sx={{
//               display: 'flex',
//               justifyContent: 'space-between',
//               gap: 2,
//               mt: 4,
//             }}
//           >
//             <Button
//               variant="outlined"
//               onClick={handleBack}
//               sx={{
//                 px: 3,
//                 py: 1,
//                 borderRadius: 1.5,
//                 textTransform: 'none',
//                 fontFamily: 'Outfit',
//                 fontSize: '13px',
//                 color: '#666',
//                 borderColor: '#e0e0e0',
//                 minWidth: { xs: '80px', sm: '100px' },
//               }}
//             >
//               Back
//             </Button>
//             <Button
//               variant="contained"
//               onClick={handleNext}
//               sx={{
//                 px: 3,
//                 py: 1,
//                 borderRadius: 1.5,
//                 textTransform: 'none',
//                 fontFamily: 'Outfit',
//                 fontSize: '13px',
//                 backgroundColor: '#1976d2',
//                 minWidth: { xs: '80px', sm: '100px' },
//                 '&:hover': {
//                   backgroundColor: '#1565c0',
//                 },
//               }}
//             >
//               Next
//             </Button>
//           </Box>
//         </Paper>
//       </Box>

//       {/* Amenities Dialog */}
//       {!isCommercial && (
//         <AmenitiesDialog
//           open={amenitiesDialogOpen}
//           onClose={handleCloseAmenitiesDialog}
//           onSave={handleSaveAmenities}
//           initialAmenities={selectedAmenities}
//         />
//       )}

//       {/* Image Preview Dialog */}
//       {imagePreviews.length > 0 && (
//         <Dialog
//           open={previewOpen}
//           onClose={() => setPreviewOpen(false)}
//           maxWidth="md"
//           fullWidth
//           sx={{
//             '& .MuiDialog-paper': {
//               borderRadius: '12px',
//               overflow: 'hidden',
//               bgcolor: 'black'
//             }
//           }}
//         >
//           <DialogContent sx={{ p: 0, position: 'relative' }}>
//             <Box
//               component="img"
//               src={imagePreviews[selectedImageIndex]}
//               alt={`Image ${selectedImageIndex + 1}`}
//               sx={{
//                 width: '100%',
//                 height: 'auto',
//                 maxHeight: '80vh',
//                 objectFit: 'contain'
//               }}
//             />
//             <IconButton
//               onClick={() => setPreviewOpen(false)}
//               sx={{
//                 position: 'absolute',
//                 top: 8,
//                 right: 8,
//                 bgcolor: 'rgba(255, 255, 255, 0.3)',
//                 color: 'white',
//                 '&:hover': {
//                   bgcolor: 'rgba(255, 255, 255, 0.5)'
//                 }
//               }}
//             >
//               <CloseIcon />
//             </IconButton>
            
//             {imagePreviews.length > 1 && (
//               <>
//                 <IconButton
//                   onClick={() => setSelectedImageIndex(prev => (prev > 0 ? prev - 1 : imagePreviews.length - 1))}
//                   sx={{
//                     position: 'absolute',
//                     left: 8,
//                     top: '50%',
//                     transform: 'translateY(-50%)',
//                     bgcolor: 'rgba(255, 255, 255, 0.3)',
//                     color: 'white',
//                     '&:hover': {
//                       bgcolor: 'rgba(255, 255, 255, 0.5)'
//                     }
//                   }}
//                 >
//                   &#8249;
//                 </IconButton>
//                 <IconButton
//                   onClick={() => setSelectedImageIndex(prev => (prev < imagePreviews.length - 1 ? prev + 1 : 0))}
//                   sx={{
//                     position: 'absolute',
//                     right: 8,
//                     top: '50%',
//                     transform: 'translateY(-50%)',
//                     bgcolor: 'rgba(255, 255, 255, 0.3)',
//                     color: 'white',
//                     '&:hover': {
//                       bgcolor: 'rgba(255, 255, 255, 0.5)'
//                     }
//                   }}
//                 >
//                   &#8250;
//                 </IconButton>
                
//                 <Box
//                   sx={{
//                     position: 'absolute',
//                     bottom: 16,
//                     left: '50%',
//                     transform: 'translateX(-50%)',
//                     bgcolor: 'rgba(0, 0, 0, 0.7)',
//                     color: 'white',
//                     px: 2,
//                     py: 1,
//                     borderRadius: '16px',
//                     fontSize: '14px',
//                     fontFamily: 'Outfit'
//                   }}
//                 >
//                   {selectedImageIndex + 1} / {imagePreviews.length}
//                 </Box>
//               </>
//             )}
//           </DialogContent>
//         </Dialog>
//       )}
//     </Container>
//   );
// };

// export default PropertyDetails;



import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Box,
  Typography,
  TextField,
  Button,
  Select,
  MenuItem,
  FormControl,
  Grid,
  IconButton,
  FormHelperText,
  InputAdornment,
  useTheme,
  useMediaQuery,
  List,
  Paper,
  ListItem,
  ListItemText,
  Popper,
  Grow,
  ClickAwayListener,
  Dialog,
  DialogContent,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CloudUpload from '@mui/icons-material/CloudUpload';
import { useSelector } from 'react-redux';
import { selectUser } from '../Commonlibs/userSlice';
import PostAccess from './PostAccess';
import apartmentIcon from "../assets/appsell.png";
import independentHouseIcon from "../assets/apphouse.png";
import duplexIcon from "../assets/appduple.png";
import pentHouseIcon from "../assets/apppent.png";
import villaIcon from "../assets/appvilla.png";
import studioIcon from "../assets/appstudio.png";
import plotIcon from "../assets/appplot.png";
import agricultureLandIcon from "../assets/appagri.png";
import farmHouseIcon from "../assets/appfarm.png";
import youtubeIcon from '../assets/appyoutu.png';
import OfficeIcon from '../assets/officecomm.png';
import ShowroomIcon from '../assets/showcomm.png';
import RetailShopIcon from '../assets/retailcomm.png';
import WarehouseIcon from '../assets/ware comm.png';
import CommercialPlotIcon from '../assets/plotcomm.png';
import OthersIcon from '../assets/otherscomm.png';
const base64ToFile = async (base64String, filename) => {
  try {
    const response = await fetch(base64String);
    const blob = await response.blob();
    return new File([blob], filename, { type: blob.type });
  } catch (error) {
    console.error('Error converting base64 to file:', error);
    return null;
  }
};

const PropertyDetails = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();
  const location = useLocation();
  
  const {
    propertyType = 'Residential', 
    category = 'Sell', 
    location: propLocation = ''
  } = location.state || {};
  
  const user = useSelector(selectUser);
  const userId = user?.id;

  // ✅ Load persisted state with proper handling
  const loadPersistedState = () => {
    const savedState = localStorage.getItem('propertyDetailsFormState');
    if (savedState) {
      try {
        return JSON.parse(savedState);
      } catch (e) {
        console.error('Error parsing saved state:', e);
        return location.state || {};
      }
    }
    return location.state || {};
  };

  const persistedState = loadPersistedState();

  // ✅ State declarations with persistence
  const [profileData, setProfileData] = useState(null);
  const [loadingProfile, setLoadingProfile] = useState(true);
  
  // ✅ Image previews with base64 persistence
  // const [imagePreviews, setImagePreviews] = useState(() => {
  //   const savedPreviews = localStorage.getItem('propertyImagePreviews');
  //   if (savedPreviews) {
  //     try {
  //       return JSON.parse(savedPreviews);
  //     } catch (e) {
  //       return [];
  //     }
  //   }
  //   return [];
  // });

  const [propertyImages, setPropertyImages] = useState([]);
  const [imagesLoaded, setImagesLoaded] = useState(false);
const [imagePreviews, setImagePreviews] = useState([]);
  const [propertyVideos, setPropertyVideos] = useState(persistedState.propertyVideos || []);
  const [buildingName, setBuildingName] = useState(persistedState.buildingName || '');
  const [areaName, setAreaName] = useState(persistedState.areaName || '');
  const [completeAddress, setCompleteAddress] = useState(persistedState.completeAddress || '');
  const [locality, setLocality] = useState(persistedState.locality || '');
  const [landmark, setLandmark] = useState(persistedState.landmark || '');
  const [propertyDescription, setPropertyDescription] = useState(persistedState.propertyDescription || '');
  const [propertyContent, setPropertyContent] = useState(persistedState.propertyContent || '');
  const [propertySize, setPropertySize] = useState(persistedState.propertySize || '');
  const [selectedUnit, setSelectedUnit] = useState(persistedState.selectedUnit || 'sq.ft');
  const [propertyLength, setPropertyLength] = useState(persistedState.propertyLength || '');
  const [lengthUnit, setLengthUnit] = useState(persistedState.lengthUnit || 'Sq.Ft');
  const [propertyWidth, setPropertyWidth] = useState(persistedState.propertyWidth || '');
  const [widthUnit, setWidthUnit] = useState(persistedState.widthUnit || 'Sq.Ft');
  const [totalFloors, setTotalFloors] = useState(persistedState.totalFloors || '');
  const [selectedFloor, setSelectedFloor] = useState(persistedState.selectedFloor || '');
  const [ownerName, setOwnerName] = useState(persistedState.ownerName || '');
  const [contactNumber, setContactNumber] = useState(persistedState.contactNumber || '');
  const [emailAddress, setEmailAddress] = useState(persistedState.emailAddress || '');
  const [youtubeLink, setYoutubeLink] = useState(persistedState.youtubeLink || '');
  const [carpetArea, setCarpetArea] = useState(persistedState.carpetArea || '');
  const [carpetAreaUnits, setCarpetAreaUnits] = useState(persistedState.carpetAreaUnits || 'Sq.Ft');
  const [builtUpArea, setBuiltUpArea] = useState(persistedState.builtUpArea || '');
  const [builtUpAreaUnits, setBuiltUpAreaUnits] = useState(persistedState.builtUpAreaUnits || 'Sq.Ft');
  const [udsArea, setUdsArea] = useState(persistedState.udsArea || '');
  const [udsAreaUnits, setUdsAreaUnits] = useState(persistedState.udsAreaUnits || 'Sq.Ft');
  const [selectedBHK, setSelectedBHK] = useState(persistedState.selectedBHK || "");
  const [selectedFurnish, setSelectedFurnish] = useState(persistedState.selectedFurnish || "");
  const [selectedHub, setSelectedHub] = useState(persistedState.selectedHub || '');
  const [selectedStatus, setSelectedStatus] = useState(persistedState.selectedStatus || '');
  const [selectedOwnership, setSelectedOwnership] = useState(persistedState.selectedOwnership || '');
  const [floorsAvailable, setFloorsAvailable] = useState(persistedState.floorsAvailable || "");
  
  const [areaSuggestions, setAreaSuggestions] = useState([]);
  const [showAreaSuggestions, setShowAreaSuggestions] = useState(false);
  const [areaAnchorEl, setAreaAnchorEl] = useState(null);
  const [selectedAreaDetails, setSelectedAreaDetails] = useState(null);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [errors, setErrors] = useState({});
  const [touchedFields, setTouchedFields] = useState({});

  const isCommercial = propertyType === 'Commercial';

  const [residentialPropertyTypes, setResidentialPropertyTypes] = useState([
    { id: "apartment", name: "Apartment", icon: apartmentIcon, selected: persistedState.selectedType === "apartment" || (!persistedState.selectedType && true) },
    { id: "independent-house", name: "Independent House", icon: independentHouseIcon, selected: persistedState.selectedType === "independent-house" },
    { id: "pent-house", name: "Pent House", icon: pentHouseIcon, selected: persistedState.selectedType === "pent-house" },
    { id: "studio", name: "Studio", icon: studioIcon, selected: persistedState.selectedType === "studio" },
    { id: "plot", name: "plot", icon: plotIcon, selected: persistedState.selectedType === "plot" },
    { id: "agriculture-land", name: "Agriculture Land", icon: agricultureLandIcon, selected: persistedState.selectedType === "agriculture-land" },
    { id: "farm-house", name: "Farm House", icon: farmHouseIcon, selected: persistedState.selectedType === "farm-house" },
  ]);

  const [commercialPropertyTypes, setCommercialPropertyTypes] = useState([
    { id: "office", name: "Office", icon: OfficeIcon, selected: persistedState.selectedType === "office" || (!persistedState.selectedType && true) },
    { id: "showroom", name: "Showroom", icon: ShowroomIcon, selected: persistedState.selectedType === "showroom" },
    { id: "retail-shop", name: "Retail Shop", icon: RetailShopIcon, selected: persistedState.selectedType === "retail-shop" },
    { id: "warehouse", name: "Warehouse", icon: WarehouseIcon, selected: persistedState.selectedType === "warehouse" },
    { id: "plot", name: "plot", icon: CommercialPlotIcon, selected: persistedState.selectedType === "plot" },
    { id: "others", name: "Others", icon: OthersIcon, selected: persistedState.selectedType === "others" },
  ]);

  const [selectedPropertyType, setSelectedPropertyType] = useState(() => {
    if (persistedState.selectedType) {
      return persistedState.selectedType;
    }
    if (isCommercial) {
      return commercialPropertyTypes.find(t => t.selected)?.id || "office";
    }
    return residentialPropertyTypes.find(t => t.selected)?.id || "apartment";
  });

// At the top of PropertyDetails component, after state declarations
useEffect(() => {
  // Check if this is a fresh entry from AddNewProperty
  const isFromAddNewProperty = location.state?.timestamp;
  const isFromBackButton = location.state?.fromBackNavigation;
  
  if (isFromAddNewProperty && !isFromBackButton) {
    // Fresh entry - clear images
    setImagePreviews([]);
    setPropertyImages([]);
    localStorage.removeItem('propertyImagePreviews');
  }
}, [location.state?.timestamp]);


  // ✅ Load images from localStorage on mount
  useEffect(() => {
    const loadImagesFromStorage = async () => {
      const savedPreviews = localStorage.getItem('propertyImagePreviews');
      if (savedPreviews) {
        try {
          const previews = JSON.parse(savedPreviews);
          if (previews && previews.length > 0) {
            setImagePreviews(previews);

            // ✅ Convert base64 back to File objects
            const filePromises = previews.map((preview, index) =>
              base64ToFile(preview, `property-image-${index + 1}.jpg`)
            );

            const files = await Promise.all(filePromises);
            const validFiles = files.filter(file => file !== null);

            if (validFiles.length > 0) {
              setPropertyImages(validFiles);
            }
          }
        } catch (e) {
          console.error('Error loading images from localStorage:', e);
        }
      }
      setImagesLoaded(true);
    };

    if (!imagesLoaded) {
      loadImagesFromStorage();
    }
  }, [imagesLoaded]);

  // ✅ Save state to localStorage whenever it changes
  useEffect(() => {
    const stateToSave = {
      propertyType,
      category,
      location: propLocation,
      selectedType: selectedPropertyType,
      buildingName,
      areaName,
      completeAddress,
      locality,
      landmark,
      propertyDescription,
      propertyContent,
      propertySize,
      selectedUnit,
      propertyLength,
      lengthUnit,
      propertyWidth,
      widthUnit,
      totalFloors,
      selectedFloor,
      ownerName,
      contactNumber,
      emailAddress,
      youtubeLink,
      carpetArea,
      carpetAreaUnits,
      builtUpArea,
      builtUpAreaUnits,
      udsArea,
      udsAreaUnits,
      selectedBHK,
      selectedFurnish,
      selectedHub,
      selectedStatus,
      selectedOwnership,
      floorsAvailable,
      imageCount: propertyImages.length,
      videoCount: propertyVideos.length,
    };
    localStorage.setItem('propertyDetailsFormState', JSON.stringify(stateToSave));
  }, [
    propertyType, category, propLocation, selectedPropertyType,
    buildingName, areaName, completeAddress, locality, landmark,
    propertyDescription, propertyContent, propertySize, selectedUnit,
    propertyLength, lengthUnit, propertyWidth, widthUnit,
    totalFloors, selectedFloor, ownerName, contactNumber, emailAddress,
    youtubeLink, carpetArea, carpetAreaUnits, builtUpArea, builtUpAreaUnits,
    udsArea, udsAreaUnits, selectedBHK, selectedFurnish, selectedHub,
    selectedStatus, selectedOwnership, floorsAvailable, propertyImages.length, propertyVideos.length
  ]);

  const bhkOptions = [
    { id: "1bhk", label: "1 BHK" },
    { id: "2bhk", label: "2 BHK" },
    { id: "3bhk", label: "3 BHK" },
    { id: "4bhk", label: "4 BHK" },
    { id: "5bhk", label: "5 BHK" },
    { id: "6bhk", label: "6 BHK" },
    { id: "6+bhk", label: "6+ BHK" },
  ];

  const furnishTypes = [
    { id: "fully", label: "Fully Furnished" },
    { id: "semi", label: "Semi Furnished" },
    { id: "un", label: "Un Furnished" },
  ];

  const hubs = ['IT Park', 'Business Park', 'Others'];
  const statuses = ['Ready to Occupy', 'Under Construction', 'Bare shell'];
  const ownerships = ['Freehold', 'Leasehold', 'Cooperative society', 'Power of attorney'];

  const getSelectedPropertyType = () => {
    if (isCommercial) {
      return commercialPropertyTypes.find(type => type.selected) || commercialPropertyTypes[0];
    }
    return residentialPropertyTypes.find(type => type.selected) || residentialPropertyTypes[0];
  };

  const calculateProgress = () => {
    const selectedType = getSelectedPropertyType();
    const isPlot = selectedType?.id === 'plot';
    const isAgricultureLand = selectedType?.id === 'agriculture-land';

    let totalFields = 0;
    let filledFields = 0;

    if (buildingName) filledFields++;
    totalFields++;

    if (areaName) filledFields++;
    totalFields++;

    if (completeAddress) filledFields++;
    totalFields++;

    if (propertyImages.length > 0 || imagePreviews.length > 0) filledFields++;
    totalFields++;

    if (isPlot || isAgricultureLand) {
      if (propertySize) filledFields++;
      totalFields++;

      if (propertyLength) filledFields++;
      totalFields++;

      if (propertyWidth) filledFields++;
      totalFields++;

      if (isPlot) {
        if (propertyDescription) filledFields++;
        totalFields++;

        if (propertyContent) filledFields++;
        totalFields++;
      }
    } else {
      if (!isCommercial) {
        if (ownerName && ownerName !== 'N/A') filledFields++;
        totalFields++;

        if (contactNumber && contactNumber !== 'N/A') filledFields++;
        totalFields++;

        if (emailAddress && emailAddress !== 'N/A') filledFields++;
        totalFields++;

        if (selectedBHK) filledFields++;
        totalFields++;

        if (selectedFurnish) filledFields++;
        totalFields++;
      }

      if (selectedType?.id !== 'apartment') {
        if (propertySize) filledFields++;
        totalFields++;
      }

      if (selectedType?.id === 'apartment' || selectedType?.id === 'independent-house' || selectedType?.id === 'duplex') {
        if (carpetArea) filledFields++;
        totalFields++;

        if (builtUpArea) filledFields++;
        totalFields++;

        if (selectedType?.id === 'independent-house') {
          if (udsArea) filledFields++;
          totalFields++;
        }
      }

      if (isCommercial && selectedType?.id !== 'plot') {
        if (totalFloors) filledFields++;
        totalFields++;

        if (selectedFloor) filledFields++;
        totalFields++;

        if (selectedHub) filledFields++;
        totalFields++;

        if (selectedOwnership) filledFields++;
        totalFields++;
      }
    }

    return Math.round((filledFields / totalFields) * 100);
  };

  const progress = calculateProgress();

  // Validation functions (keep all your existing validation functions)
  const validateAlphanumeric = (text, fieldName) => {
    if (!text || !text.trim()) return `${fieldName} is required`;
    if (text.trim().length < 3) return `${fieldName} must be at least 3 characters`;
    return "";
  };

  const validateName = (name) => {
    if (!name || !name.trim()) return "Name is required";
    if (name.trim().length < 3) return "Name must be at least 3 characters";
    return "";
  };

  const validateNumber = (value, fieldName, min = 1, max = null) => {
    if (!value || value === "") return `${fieldName} is required`;
    const numValue = Number(value);
    if (isNaN(numValue)) return `${fieldName} must be a number`;
    if (numValue < min) return `${fieldName} must be at least ${min}`;
    if (max !== null && numValue > max) return `${fieldName} must be less than ${max}`;
    return "";
  };

  const validateEmail = (email) => {
    if (!email || !email.trim()) return "Email is required";
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(email)) return "Please enter a valid email address";
    return "";
  };

  const validatePhone = (phone) => {
    if (!phone || !phone.trim()) return "Phone number is required";
    const phoneRegex = /^[0-9]{10}$/;
    if (!phoneRegex.test(phone)) return "Phone must be exactly 10 digits";
    return "";
  };

  const validateCompleteAddress = (value) => {
    if (!value || !value.trim()) return "Complete address is required";
    if (value.trim().length < 10) return "Complete address must be at least 10 characters";
    return "";
  };

  const validateYouTubeLink = (link) => {
    if (!link || !link.trim()) return "";
    const youtubeRegex = /^(https?:\/\/)?(www\.)?(youtube\.com\/watch\?v=|youtu\.be\/)[a-zA-Z0-9\\_-]{11}(\?.*)?$/;
    if (!youtubeRegex.test(link)) return "Please enter a valid YouTube video link";
    return "";
  };

  const validateUdsArea = (value, propertyType) => {
    const selectedType = getSelectedPropertyType();
    const typeId = propertyType || selectedType?.id;

    if (typeId === 'independent-house') {
      if (!value || value.trim() === "") {
        return "UDS (Undivided Share) is required for Independent House properties";
      }
    }

    if (!value || value === "") return "";

    const numValue = Number(value);
    if (isNaN(numValue)) return "UDS area must be a number";
    if (numValue < 1) return "UDS area must be at least 1";
    return "";
  };

  useEffect(() => {
    const fetchUserProfile = async () => {
      if (!userId) {
        setLoadingProfile(false);
        return;
      }

      try {
        setLoadingProfile(true);
        const response = await fetch(`https://propertydealstalk.com/api/users/getUserProfile?user_id=${userId}`);
        const data = await response.json();

        if (data.status === "SUCCESS") {
          setProfileData(data.result);
          if (data.result.full_name) {
            setOwnerName(data.result.full_name);
          } else {
            setOwnerName('N/A');
          }

          if (data.result.contact_number) {
            setContactNumber(data.result.contact_number);
          } else {
            setContactNumber('N/A');
          }

          if (data.result.email_id) {
            setEmailAddress(data.result.email_id);
          } else {
            setEmailAddress('N/A');
          }
        }
      } catch (err) {
        console.error('Error fetching profile:', err);
      } finally {
        setLoadingProfile(false);
      }
    };

    fetchUserProfile();
  }, [userId]);

  const handleAreaNameChange = (e) => {
    const value = e.target.value;
    setAreaName(value);
    setAreaAnchorEl(e.currentTarget);

    if (!value) {
      setErrors(prev => ({...prev, areaName: 'Area Name is required'}));
    } else if (value.trim().length < 1) {
      setErrors(prev => ({...prev, areaName: 'Area Name must be at least 3 characters'}));
    } else {
      setErrors(prev => ({...prev, areaName: ''}));
    }
  };

  const handleSelectArea = (area) => {
    setAreaName(area.area);
    setSelectedAreaDetails({
      name: area.area,
      address: area.address,
      location: area.location
    });
    setAreaAnchorEl(null);
    setShowAreaSuggestions(false);
    setErrors(prev => ({...prev, areaName: ''}));
  };

  const handleAreaClickAway = () => {
    setShowAreaSuggestions(false);
  };

  const fetchAreaSuggestions = async (query, city) => {
    if (query.length < 1 || !city) return;

    try {
      const response = await fetch(`https://propertydealstalk.com/api/property/getAreasByCity?city=${encodeURIComponent(city)}&q=${encodeURIComponent(query)}`);
      const data = await response.json();

      if (data.success && data.areas && data.areas.length > 0) {
        const transformedAreas = data.areas.map(area => ({
          area: area.name,
          address: area.address,
          location: area.location
        }));
        setAreaSuggestions(transformedAreas);
        setShowAreaSuggestions(true);
      } else {
        setAreaSuggestions([]);
        setShowAreaSuggestions(false);
      }
    } catch (error) {
      console.error('Error fetching area suggestions:', error);
      setAreaSuggestions([]);
      setShowAreaSuggestions(false);
    }
  };

  useEffect(() => {
    if (areaName.trim().length > 0 && location.state?.location) {
      fetchAreaSuggestions(areaName, location.state.location);
    } else {
      setAreaSuggestions([]);
      setShowAreaSuggestions(false);
    }
  }, [areaName, location.state?.location]);

  // ✅ Enhanced image upload with base64 persistence
  const handleImageUpload = (event) => {
    const files = event.target.files;
    if (!files || files.length === 0) return;

    if (files.length > 10) {
      alert("You can only upload up to 10 images");
      return;
    }

    const validFiles = Array.from(files).filter(file => file.type.startsWith('image/'));

    if (validFiles.length !== files.length) {
      alert("Only image files are allowed (JPEG, PNG, GIF, etc.)");
      return;
    }

    const newPreviews = [];
    const fileProcessPromises = validFiles.map(file => {
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          newPreviews.push(e.target.result); // base64 string
          resolve();
        };
        reader.onerror = () => {
          console.error(`Failed to read file: ${file.name}`);
          resolve();
        };
        reader.readAsDataURL(file);
      });
    });

    Promise.all(fileProcessPromises).then(() => {
         
      const updatedPreviews = [...imagePreviews, ...newPreviews];
      const updatedFiles = [...propertyImages, ...validFiles];

      setImagePreviews(updatedPreviews);
      setPropertyImages(updatedFiles);
     localStorage.setItem('propertyImagePreviews', JSON.stringify(updatedPreviews));
    });
  };

  // ✅ Reset fields when property type changes
  const handlePropertyTypeSelect = (typeId) => {
    const previousType = selectedPropertyType;
    setSelectedPropertyType(typeId);

    // Clear type-specific fields when switching between plot and non-plot
    if (previousType !== typeId) {
      const isPlot = typeId === 'plot';
      const isAgricultureLand = typeId === 'agriculture-land';
      const wasPlot = previousType === 'plot';
      const wasAgricultureLand = previousType === 'agriculture-land';

      // Switching TO plot/agriculture from regular property
      if ((isPlot || isAgricultureLand) && (!wasPlot && !wasAgricultureLand)) {
        setSelectedBHK('');
        setSelectedFurnish('');
        setCarpetArea('');
        setBuiltUpArea('');
        setUdsArea('');
        setOwnerName('');
        setContactNumber('');
        setEmailAddress('');
        setYoutubeLink('');
        setTotalFloors('');
        setSelectedFloor('');
      } 
      // Switching FROM plot/agriculture to regular property
      else if ((!isPlot && !isAgricultureLand) && (wasPlot || wasAgricultureLand)) {
        setPropertyDescription('');
        setPropertyContent('');
        setPropertyLength('');
        setPropertyWidth('');
        setLandmark('');
      }

      setErrors({});
    }

    if (isCommercial) {
      const updatedTypes = commercialPropertyTypes.map(type => ({
        ...type,
        selected: type.id === typeId
      }));
      setCommercialPropertyTypes(updatedTypes);
    } else {
      const updatedTypes = residentialPropertyTypes.map(type => ({
        ...type,
        selected: type.id === typeId
      }));
      setResidentialPropertyTypes(updatedTypes);
    }
  };

  const handleBack = () => {
    navigate('/add-new-property', {
      state: {
        propertyType: propertyType,
        category: category,
        location: location.state?.location || propLocation || localStorage.getItem('propertyLocation') || '',
        asset_type: getSelectedPropertyType()?.name || '',
        selectedType: getSelectedPropertyType()?.id || ''
      }
    });
  };

  // ✅ Enhanced handleNext with proper amenities logic
  const handleNext = () => {
    let selectedType = null;
    if (isCommercial) {
      selectedType = commercialPropertyTypes.find(type => type.selected);
    } else {
      selectedType = residentialPropertyTypes.find(type => type.selected);
    }

    const isPlot = selectedType?.id === 'plot';
    const isAgricultureLand = selectedType?.id === 'agriculture-land';
    

    let validationErrors = {
      buildingName: validateAlphanumeric(buildingName, "Building name"),
      areaName: validateName(areaName),
      ...(selectedType?.id !== 'apartment' && {
        propertySize: validateNumber(propertySize, "Property size")
      })
    };

    if (isPlot || isAgricultureLand) {
      validationErrors = {
        ...validationErrors,
        completeAddress: validateCompleteAddress(completeAddress),
        propertyLength: validateNumber(propertyLength, "Length"),
        propertyWidth: validateNumber(propertyWidth, "Width"),
      };

      if (isPlot) {
        validationErrors.propertyDescription = validateName(propertyDescription);
        validationErrors.propertyContent = validateName(propertyContent);
      }
    } else if (selectedType?.id === 'independent-house') {
      validationErrors.udsArea = validateUdsArea(udsArea, selectedType?.id);
      validationErrors.completeAddress = validateCompleteAddress(completeAddress);
      validationErrors.carpetArea = validateNumber(carpetArea, "Carpet area");
      validationErrors.builtUpArea = validateNumber(builtUpArea, "Built-up area");

      if (!isCommercial) {
        validationErrors = {
          ...validationErrors,
          ownerName: (ownerName === 'N/A' || !ownerName) ? 'Owner name is required' : validateName(ownerName),
          contactNumber: (contactNumber === 'N/A' || !contactNumber) ? 'Contact number is required' : validatePhone(contactNumber),
          emailAddress: (emailAddress === 'N/A' || !emailAddress) ? 'Email address is required' : validateEmail(emailAddress),
          bhk: selectedBHK ? '' : 'Please select BHK',
          furnish: selectedFurnish ? '' : 'Please select furnish type',
        };
      }
    } else if (selectedType?.id === 'apartment' || selectedType?.id === 'duplex') {
      validationErrors.carpetArea = validateNumber(carpetArea, "Carpet area");
      validationErrors.builtUpArea = validateNumber(builtUpArea, "Built-up area");

      if (udsArea && udsArea.trim() !== '') {
        validationErrors.udsArea = validateUdsArea(udsArea, selectedType?.id);
      }

      validationErrors.completeAddress = validateCompleteAddress(completeAddress);

      if (!isCommercial) {
        validationErrors = {
          ...validationErrors,
          ownerName: (ownerName === 'N/A' || !ownerName) ? 'Owner name is required' : validateName(ownerName),
          contactNumber: (contactNumber === 'N/A' || !contactNumber) ? 'Contact number is required' : validatePhone(contactNumber),
          emailAddress: (emailAddress === 'N/A' || !emailAddress) ? 'Email address is required' : validateEmail(emailAddress),
          bhk: selectedBHK ? '' : 'Please select BHK',
          furnish: selectedFurnish ? '' : 'Please select furnish type',
        };
      }
    } else if (isCommercial && !isPlot) {
      validationErrors = {
        ...validationErrors,
        totalFloors: validateNumber(totalFloors, "Total floors", 1, 100),
        selectedFloor: selectedFloor ? '' : 'Please select floor',
        propertySize: validateNumber(propertySize, "Property size"),
      };
    }

    if (youtubeLink && youtubeLink.trim()) {
      validationErrors.youtubeLink = validateYouTubeLink(youtubeLink);
    }

    setErrors(validationErrors);

    const hasErrors = Object.values(validationErrors).some(error => error);

    if (hasErrors) {
      const firstErrorField = Object.keys(validationErrors).find(key => validationErrors[key]);
      if (firstErrorField) {
        const element = document.getElementById(firstErrorField);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'center' });
          element.focus();
        }
      }
      return;
    }

    const propertyDetails = {
      propertyType: isCommercial ? 'Commercial' : 'Residential',
      category: category,
      location: location.state?.location || propLocation || '',
      asset_type: selectedType?.name || '',
      selectedType: selectedType?.id || '',
      property_name: buildingName || '',
      buildingName: buildingName || '',
      area_name: areaName || '',
      areaName: areaName || '',
      landmark: landmark || '',
      description: (isPlot ? propertyDescription : '') || '',
      content: (isPlot ? propertyContent : '') || '',
      propertyDescription: propertyDescription || '',
      propertyContent: propertyContent || '',
      bhk: (!isPlot && !isAgricultureLand && !isCommercial) ? (selectedBHK || '') : '',
      furnish_type: (!isPlot && !isAgricultureLand && !isCommercial) ? (selectedFurnish || '') : '',
      full_address: completeAddress || '',
      completeAddress: completeAddress || '',
      locality: (!isPlot && !isAgricultureLand) ? (locality || '') : null,
      carpet_area: (selectedType?.id === 'apartment' || selectedType?.id === 'independent-house' || selectedType?.id === 'duplex') ? (carpetArea || '') : '',
      carpet_area_units: (selectedType?.id === 'apartment' || selectedType?.id === 'independent-house' || selectedType?.id === 'duplex') ? (carpetAreaUnits || '') : '',
      built_up_area: (selectedType?.id === 'apartment' || selectedType?.id === 'independent-house' || selectedType?.id === 'duplex') ? (builtUpArea || '') : '',
      built_up_area_units: (selectedType?.id === 'apartment' || selectedType?.id === 'independent-house' || selectedType?.id === 'duplex') ? (builtUpAreaUnits || '') : '',
      uds_area: (selectedType?.id === 'apartment' || selectedType?.id === 'independent-house' || selectedType?.id === 'duplex') ? (udsArea || '') : '',
      uds_area_units: (selectedType?.id === 'apartment' || selectedType?.id === 'independent-house' || selectedType?.id === 'duplex') ? (udsAreaUnits || 'Sq.Ft') : '',
      property_size: propertySize || '',
      propertySize: propertySize || '',
      property_size_units: selectedUnit || 'sq.ft',
      selectedUnit: selectedUnit || 'sq.ft',
      length: propertyLength || '',
      width: propertyWidth || '',
      propertyLength: propertyLength || '',
      propertyWidth: propertyWidth || '',
      lengthUnit: lengthUnit || 'Sq.Ft',
      widthUnit: widthUnit || 'Sq.Ft',
      total_floors: (!isPlot && !isAgricultureLand) ? (totalFloors || '') : '',
      totalFloors: (!isPlot && !isAgricultureLand) ? (totalFloors || '') : '',
      select_floor: (!isPlot && !isAgricultureLand) ? (selectedFloor || '') : '',
      selectedFloor: (!isPlot && !isAgricultureLand) ? (selectedFloor || '') : '',
      propertyImages: propertyImages || [],
      propertyVideos: propertyVideos || [],
      youtube_link: youtubeLink?.trim() || '',
      youtubeLink: youtubeLink?.trim() || '',
      ownerName: (!isPlot && !isAgricultureLand && !isCommercial) ? (ownerName || '') : '',
      contactNumber: (!isPlot && !isAgricultureLand && !isCommercial) ? (contactNumber || '') : '',
      emailAddress: (!isPlot && !isAgricultureLand && !isCommercial) ? (emailAddress || '') : '',
    };

    if (isCommercial) {
      propertyDetails.commercial_catgory = category.toLowerCase() === 'sell' ? 'sale' : 'rent';
      propertyDetails.commercial_asset_type = selectedType?.name || '';
      propertyDetails.hub = selectedHub || '';
      propertyDetails.ownership = selectedOwnership || '';
      propertyDetails.floors_available = floorsAvailable || '';
    }

    // ✅ CRITICAL: Proper amenities navigation logic
    const shouldShowAmenities = !isCommercial && !isPlot && !isAgricultureLand;

    if (shouldShowAmenities) {
      // Navigate to Amenities for Residential (except Plot & Agriculture Land)
      navigate('/amenities', { state: propertyDetails });
    } else {

      localStorage.removeItem('amenities_society');
    localStorage.removeItem('amenities_furnishing');
    localStorage.removeItem('amenities_other');
      // Skip Amenities, go directly to Price/Rent Details
      if (category === 'Rent') {
        navigate('/rent-details', { state: propertyDetails });
      } else if (category === 'Sell') {
        navigate('/price-details', { state: propertyDetails });
      }
    }
  };

  useEffect(() => {
    if (isCommercial) {
      if (!selectedHub) setSelectedHub('Business Park');
      if (!selectedStatus) setSelectedStatus('Ready to Occupy');
      if (!selectedOwnership) setSelectedOwnership('Freehold');
    }
  }, [isCommercial]);

  const renderForm = () => {
    const selectedType = getSelectedPropertyType();
    const isPlot = selectedType?.id === 'plot';
    const isAgricultureLand = selectedType?.id === 'agriculture-land';

    return (
      <Box>
        {/* Property Type & Upload Images */}
        <Grid container spacing={2} sx={{ mb: 3 }}>
          <Grid item xs={12} sm="auto">
            <Box sx={{ width: '410px', maxWidth: '100%' }}>
              <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                Property Type <span style={{ color: '#d32f2f' }}>*</span>
              </Typography>
              <FormControl fullWidth size="small">
                <Select
                  value={selectedPropertyType}
                  onChange={(e) => handlePropertyTypeSelect(e.target.value)}
                  displayEmpty
                  sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                  renderValue={(selected) => {
                    const propertyTypes = isCommercial ? commercialPropertyTypes : residentialPropertyTypes;
                    const selectedTypeObj = propertyTypes.find(type => type.id === selected);
                    if (!selectedTypeObj) {
                      return <em style={{ color: '#999' }}>Select Property Type</em>;
                    }
                    return (
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Box
                          component="img"
                          src={selectedTypeObj.icon}
                          alt={selectedTypeObj.name}
                          sx={{ width: 20, height: 20, objectFit: 'contain' }}
                        />
                        <Typography sx={{ fontFamily: 'Outfit', fontSize: '13px' }}>
                          {selectedTypeObj.name}
                        </Typography>
                      </Box>
                    );
                  }}
                >
                  {(isCommercial ? commercialPropertyTypes : residentialPropertyTypes).map((type) => (
                    <MenuItem key={type.id} value={type.id}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Box
                          component="img"
                          src={type.icon}
                          alt={type.name}
                          sx={{ width: 20, height: 20, objectFit: 'contain' }}
                        />
                        {type.name}
                      </Box>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </Grid>

          <Grid item xs={12} sm="auto">
            <Box sx={{ width: '410px', maxWidth: '100%' }}>
              <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                Upload Images
              </Typography>
              <Box
                sx={{
                  height: 36,
                  border: '2px dashed #d0d0d0',
                  borderRadius: 1.5,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  '&:hover': {
                    backgroundColor: '#f9f9f9',
                    borderColor: '#1976d2'
                  },
                }}
                onClick={() => document.getElementById('property-images').click()}
              >
                <input
                  type="file"
                  id="property-images"
                  multiple
                  accept="image/*"
                  style={{ display: 'none' }}
                  onChange={handleImageUpload}
                />
                <CloudUpload sx={{ width: 24, height: 24, mr: 1, color: '#1976d2' }} />
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#666', fontFamily: 'Outfit' }}>
                  Upload (Max 10)
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>

        {/* ✅ Display uploaded images from base64 */}
        {imagePreviews && imagePreviews.length > 0 && (
          <Box sx={{ mb: 3 }}>
            <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 1 }}>
              {imagePreviews.length} {imagePreviews.length === 1 ? 'image' : 'images'} uploaded
            </Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5, p: 2, border: '1px solid #e0e0e0', borderRadius: 1.5, backgroundColor: '#fafafa' }}>
              {imagePreviews.map((preview, index) => (
                <Box
                  key={`img-preview-${index}`}
                  sx={{
                    position: 'relative',
                    width: '100px',
                    height: '100px',
                    borderRadius: 1.5,
                    overflow: 'hidden',
                    border: '2px solid #e0e0e0',
                    cursor: 'pointer',
                    flexShrink: 0,
                    '&:hover': { borderColor: '#1976d2' }
                  }}
                  onClick={() => {
                    setSelectedImageIndex(index);
                    setPreviewOpen(true);
                  }}>
                  <Box
                    component="img"
                    src={preview}
                    alt={`Preview ${index + 1}`}
                    sx={{ width: '100%', height: '100%', objectFit: 'cover' }}
                  />
                  <IconButton
                    size="small"
                    sx={{
                      position: 'absolute',
                      top: -8,
                      right: -8,
                      bgcolor: '#ff4444',
                      color: 'white',
                      width: 24,
                      height: 24,
                      fontSize: '14px',
                      '&:hover': { bgcolor: '#cc0000' }
                    }}
                  onClick={(e) => {
  e.stopPropagation();
  const newPreviews = [...imagePreviews];
  const newFiles = [...propertyImages];
  newPreviews.splice(index, 1);
  newFiles.splice(index, 1);
  setImagePreviews(newPreviews);
  setPropertyImages(newFiles);
  // ✅ Update localStorage
  if (newPreviews.length > 0) {
    localStorage.setItem('propertyImagePreviews', JSON.stringify(newPreviews));
  } else {
    localStorage.removeItem('propertyImagePreviews');
  }
}}>
                    ×
                  </IconButton>
                </Box>
              ))}
            </Box>
          </Box>
        )}

        {/* Building Name & Area Name */}
        <Grid container spacing={2} sx={{ mb: 3 }}>
          <Grid item xs={12} sm="auto">
            <Box sx={{ width: '410px', maxWidth: '100%' }}>
              <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                Building/Project Name <span style={{ color: '#d32f2f' }}>*</span>
              </Typography>
              <TextField
                id="buildingName"
                fullWidth
                size="small"
                placeholder="Enter building name"
                value={buildingName}
                onChange={(e) => {
                  setBuildingName(e.target.value);
                  setErrors(prev => ({...prev, buildingName: validateAlphanumeric(e.target.value, "Building name")}));
                }}
                error={!!errors.buildingName}
                helperText={errors.buildingName}
                sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
              />
            </Box>
          </Grid>

          <Grid item xs={12} sm="auto">
            <Box sx={{ width: '410px', maxWidth: '100%' }}>
              <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                Area Name <span style={{ color: '#d32f2f' }}>*</span>
              </Typography>
              <ClickAwayListener onClickAway={handleAreaClickAway}>
                <Box sx={{ position: 'relative' }}>
                  <TextField
                    id="areaName"
                    fullWidth
                    size="small"
                    placeholder="Enter area name"
                    value={areaName}
                    onChange={handleAreaNameChange}
                    error={!!errors.areaName}
                    helperText={errors.areaName}
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                  />
                  {showAreaSuggestions && areaSuggestions.length > 0 && (
                    <Popper
                      open={showAreaSuggestions}
                      anchorEl={areaAnchorEl}
                      placement="bottom-start"
                      transition
                      style={{ width: areaAnchorEl ? areaAnchorEl.clientWidth : 'auto', zIndex: 1300 }}>
                      {({ TransitionProps }) => (
                        <Grow {...TransitionProps} timeout={200}>
                          <Paper elevation={3} sx={{ maxHeight: 200, overflow: 'auto', mt: 0.5, border: '1px solid #e0e0e0', borderRadius: 1 }}>
                            <List dense>
                              {areaSuggestions.map((area, index) => (
                                <ListItem
                                  key={index}
                                  button
                                  onClick={() => handleSelectArea(area)}
                                  sx={{ py: 0.8, '&:hover': { backgroundColor: '#f5f5f5' } }}>
                                  <ListItemText
                                    primary={area.area}
                                    primaryTypographyProps={{ fontFamily: 'Outfit', fontWeight: 500, fontSize: '13px' }}
                                  />
                                </ListItem>
                              ))}
                            </List>
                          </Paper>
                        </Grow>
                      )}
                    </Popper>
                  )}
                </Box>
              </ClickAwayListener>
            </Box>
          </Grid>
        </Grid>

        {/* Complete Address */}
        {(!isCommercial || isPlot) && (
          <Box sx={{ mb: 3 }}>
            <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
              Complete Address <span style={{ color: '#d32f2f' }}>*</span>
            </Typography>
            <TextField
              id="completeAddress"
              fullWidth
              size="small"
              multiline
              rows={2}
              placeholder="Enter complete address"
              value={completeAddress}
              onChange={(e) => {
                setCompleteAddress(e.target.value);
                setErrors(prev => ({...prev, completeAddress: validateCompleteAddress(e.target.value)}));
              }}
              error={!!errors.completeAddress}
              helperText={errors.completeAddress}
              sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
            />
          </Box>
        )}

        {/* Plot & Agriculture Land Specific Fields */}
        {(isPlot || isAgricultureLand) && (
          <>
            {isPlot && (
              <Grid container spacing={2} sx={{ mb: 3 }}>
                <Grid item xs={12} sm="auto">
                  <Box sx={{ width: '410px', maxWidth: '100%' }}>
                    <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                      Description <span style={{ color: '#d32f2f' }}>*</span>
                    </Typography>
                    <TextField
                      id="propertyDescription"
                      fullWidth
                      size="small"
                      multiline
                      rows={3}
                      placeholder="Short description"
                      value={propertyDescription}
                      onChange={(e) => {
                        setPropertyDescription(e.target.value);
                        setErrors(prev => ({...prev, propertyDescription: validateName(e.target.value)}));
                      }}
                      error={!!errors.propertyDescription}
                      helperText={errors.propertyDescription}
                      sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                    />
                  </Box>
                </Grid>

                <Grid item xs={12} sm="auto">
                  <Box sx={{ width: '410px', maxWidth: '100%' }}>
                    <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                      Content <span style={{ color: '#d32f2f' }}>*</span>
                    </Typography>
                    <TextField
                      id="propertyContent"
                      fullWidth
                      size="small"
                      multiline
                      rows={3}
                      placeholder="Content"
                      value={propertyContent}
                      onChange={(e) => {
                        setPropertyContent(e.target.value);
                        setErrors(prev => ({...prev, propertyContent: validateName(e.target.value)}));
                      }}
                      error={!!errors.propertyContent}
                      helperText={errors.propertyContent}
                      sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                    />
                  </Box>
                </Grid>
              </Grid>
            )}

            {/* Property Size, Length, Width */}
            <Grid container spacing={2} sx={{ mb: 3 }}>
              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '270px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                    Property Size <span style={{ color: '#d32f2f' }}>*</span>
                  </Typography>
                  <Grid container spacing={1}>
                    <Grid item xs="auto">
                      <Box sx={{ width: '180px' }}>
                        <TextField
                          id="propertySize"
                          fullWidth
                          size="small"
                          placeholder="Enter size"
                          value={propertySize}
                          onChange={(e) => {
                            const value = e.target.value.replace(/[^0-9]/g, '');
                            setPropertySize(value);
                            setErrors(prev => ({...prev, propertySize: validateNumber(value, "Property size")}));
                          }}
                          error={!!errors.propertySize}
                          helperText={errors.propertySize}
                          sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                        />
                      </Box>
                    </Grid>
                    <Grid item xs="auto">
                      <Box sx={{ width: '80px' }}>
                        <FormControl fullWidth size="small">
                          <Select
                            value={selectedUnit}
                            onChange={(e) => setSelectedUnit(e.target.value)}
                            sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}>
                            <MenuItem value="sq.ft">Sq. ft</MenuItem>
                            <MenuItem value="sqm">Sq. m</MenuItem>
                            <MenuItem value="acres">Acres</MenuItem>
                            <MenuItem value="sq.yards">Sq. yards</MenuItem>
                          </Select>
                        </FormControl>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>

              <Grid item xs={6} sm="auto">
                <Box sx={{ width: '270px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                    Length <span style={{ color: '#d32f2f' }}>*</span>
                  </Typography>
                  <Grid container spacing={0.5}>
                    <Grid item xs="auto">
                      <Box sx={{ width: '180px' }}>
                        <TextField
                          id="propertyLength"
                          fullWidth
                          size="small"
                          placeholder="Length"
                          value={propertyLength}
                          onChange={(e) => {
                            const value = e.target.value.replace(/[^0-9]/g, '');
                            setPropertyLength(value);
                            setErrors(prev => ({...prev, propertyLength: validateNumber(value, "Length")}));
                          }}
                          error={!!errors.propertyLength}
                          helperText={errors.propertyLength}
                          sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                        />
                      </Box>
                    </Grid>
                    <Grid item xs="auto">
                      <Box sx={{ width: '80px' }}>
                        <FormControl fullWidth size="small">
                          <Select
                            value={lengthUnit}
                            onChange={(e) => setLengthUnit(e.target.value)}
                            sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '11px' }}>
                            <MenuItem value="Sq.Ft">Sq.Ft</MenuItem>
                            <MenuItem value="Sq.M">Sq.M</MenuItem>
                            <MenuItem value="Yards">Yards</MenuItem>
                          </Select>
                        </FormControl>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>

              <Grid item xs={6} sm="auto">
                <Box sx={{ width: '270px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                    Width <span style={{ color: '#d32f2f' }}>*</span>
                  </Typography>
                  <Grid container spacing={0.5}>
                    <Grid item xs="auto">
                      <Box sx={{ width: '180px' }}>
                        <TextField
                          id="propertyWidth"
                          fullWidth
                          size="small"
                          placeholder="Width"
                          value={propertyWidth}
                          onChange={(e) => {
                            const value = e.target.value.replace(/[^0-9]/g, '');
                            setPropertyWidth(value);
                            setErrors(prev => ({...prev, propertyWidth: validateNumber(value, "Width")}));
                          }}
                          error={!!errors.propertyWidth}
                          helperText={errors.propertyWidth}
                          sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                        />
                      </Box>
                    </Grid>
                    <Grid item xs="auto">
                      <Box sx={{ width: '80px' }}>
                        <FormControl fullWidth size="small">
                          <Select
                            value={widthUnit}
                            onChange={(e) => setWidthUnit(e.target.value)}
                            sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '11px' }}>
                            <MenuItem value="Sq.Ft">Sq.Ft</MenuItem>
                            <MenuItem value="Sq.M">Sq.M</MenuItem>
                            <MenuItem value="Yards">Yards</MenuItem>
                          </Select>
                        </FormControl>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            </Grid>

            {/* Landmark for Agriculture Land */}
            {isAgricultureLand && (
              <Box sx={{ mb: 3 }}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  Landmark (Optional)
                </Typography>
                <Box sx={{ width: '410px', maxWidth: '100%' }}>
                  <TextField
                    id="landmark"
                    fullWidth
                    size="small"
                    placeholder="Enter nearby landmark"
                    value={landmark}
                    onChange={(e) => setLandmark(e.target.value)}
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                  />
                </Box>
              </Box>
            )}
          </>
        )}

        {/* NON-PLOT & NON-AGRICULTURE LAND RESIDENTIAL FIELDS */}
        {!isPlot && !isAgricultureLand && !isCommercial && (
          <>
            {/* YouTube Link, BHK, Furnish Type */}
            <Grid container spacing={2} sx={{ mb: 3 }}>
              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '270px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                    YouTube Link (Optional)
                  </Typography>
                  <TextField
                    id="youtubeLink"
                    fullWidth
                    size="small"
                    type="url"
                    placeholder="Paste YouTube link"
                    value={youtubeLink}
                    onChange={(e) => {
                      setYoutubeLink(e.target.value);
                      if (e.target.value) {
                        setErrors(prev => ({...prev, youtubeLink: validateYouTubeLink(e.target.value)}));
                      } else {
                        setErrors(prev => ({...prev, youtubeLink: ''}));
                      }
                    }}
                    error={!!errors.youtubeLink}
                    helperText={errors.youtubeLink}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Box component="img" src={youtubeIcon} alt="YouTube" sx={{ width: 24, height: 18 }} />
                        </InputAdornment>
                      ),
                    }}
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '270px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                    BHK <span style={{ color: '#d32f2f' }}>*</span>
                  </Typography>
                  <FormControl fullWidth size="small" error={!!errors.bhk}>
                    <Select
                      value={selectedBHK}
                      onChange={(e) => {
                        setSelectedBHK(e.target.value);
                        setErrors({...errors, bhk: ''});
                      }}
                      displayEmpty
                      sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}>
                      <MenuItem value="" disabled><em>Select BHK</em></MenuItem>
                      {bhkOptions.map((option) => (
                        <MenuItem key={option.id} value={option.id}>{option.label}</MenuItem>
                      ))}
                    </Select>
                    {errors.bhk && <FormHelperText sx={{ fontSize: '11px' }}>{errors.bhk}</FormHelperText>}
                  </FormControl>
                </Box>
              </Grid>

                            <Grid item xs={12} sm="auto">
                <Box sx={{ width: '270px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                    Furnish Type <span style={{ color: '#d32f2f' }}>*</span>
                  </Typography>
                  <FormControl fullWidth size="small" error={!!errors.furnish}>
                    <Select
                      value={selectedFurnish}
                      onChange={(e) => {
                        setSelectedFurnish(e.target.value);
                        setErrors({...errors, furnish: ''});
                      }}
                      displayEmpty
                      sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}>
                      <MenuItem value="" disabled><em>Select Furnish Type</em></MenuItem>
                      {furnishTypes.map((type) => (
                        <MenuItem key={type.id} value={type.id}>{type.label}</MenuItem>
                      ))}
                    </Select>
                    {errors.furnish && <FormHelperText sx={{ fontSize: '11px' }}>{errors.furnish}</FormHelperText>}
                  </FormControl>
                </Box>
              </Grid>
            </Grid>

            {/* Contact Information */}
            <Box sx={{ mb: 3 }}>
              <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#333', fontFamily: 'Outfit', mb: 2 }}>
                Contact Information <span style={{ color: '#d32f2f' }}>*</span>
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm="auto">
                  <Box sx={{ width: '270px', maxWidth: '100%' }}>
                    <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
                      Owner Name
                    </Typography>
                    <TextField
                      id="ownerName"
                      fullWidth
                      size="small"
                      placeholder="Enter owner name"
                      value={ownerName}
                      onChange={(e) => {
                        setOwnerName(e.target.value);
                        if (e.target.value !== 'N/A') {
                          setErrors(prev => ({...prev, ownerName: validateName(e.target.value)}));
                        }
                      }}
                      disabled={profileData?.full_name && profileData.full_name !== '' && profileData.full_name !== 'N/A'}
                      error={!!errors.ownerName}
                      helperText={errors.ownerName}
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          borderRadius: 1.5,
                          fontFamily: 'Outfit',
                          fontSize: '13px',
                          backgroundColor: (profileData?.full_name && profileData.full_name !== '' && profileData.full_name !== 'N/A') ? '#f5f5f5' : 'white'
                        }
                      }}
                    />
                  </Box>
                </Grid>

                <Grid item xs={12} sm="auto">
                  <Box sx={{ width: '270px', maxWidth: '100%' }}>
                    <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
                      Contact Number
                    </Typography>
                    <TextField
                      id="contactNumber"
                      fullWidth
                      size="small"
                      type="tel"
                      placeholder="Enter contact number"
                      value={contactNumber}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value === 'N/A' || value === '') {
                          setContactNumber(value);
                        } else {
                          const numericValue = value.replace(/\D/g, '').slice(0, 10);
                          setContactNumber(numericValue);
                          if (numericValue !== 'N/A') {
                            setErrors(prev => ({...prev, contactNumber: validatePhone(numericValue)}));
                          }
                        }
                      }}
                      disabled={profileData?.contact_number && profileData.contact_number !== '' && profileData.contact_number !== 'N/A'}
                      error={!!errors.contactNumber}
                      helperText={errors.contactNumber}
                      inputProps={{ maxLength: 10 }}
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          borderRadius: 1.5,
                          fontFamily: 'Outfit',
                          fontSize: '13px',
                          backgroundColor: (profileData?.contact_number && profileData.contact_number !== '' && profileData.contact_number !== 'N/A') ? '#f5f5f5' : 'white'
                        }
                      }}
                    />
                  </Box>
                </Grid>

                <Grid item xs={12} sm="auto">
                  <Box sx={{ width: '270px', maxWidth: '100%' }}>
                    <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
                      Email Address
                    </Typography>
                    <TextField
                      id="emailAddress"
                      fullWidth
                      size="small"
                      type="email"
                      placeholder="Enter email address"
                      value={emailAddress}
                      onChange={(e) => {
                        setEmailAddress(e.target.value);
                        if (e.target.value !== 'N/A') {
                          setErrors(prev => ({...prev, emailAddress: validateEmail(e.target.value)}));
                        }
                      }}
                      disabled={profileData?.email_id && profileData.email_id !== '' && profileData.email_id !== 'N/A'}
                      error={!!errors.emailAddress}
                      helperText={errors.emailAddress}
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          borderRadius: 1.5,
                          fontFamily: 'Outfit',
                          fontSize: '13px',
                          backgroundColor: (profileData?.email_id && profileData.email_id !== '' && profileData.email_id !== 'N/A') ? '#f5f5f5' : 'white'
                        }
                      }}
                    />
                  </Box>
                </Grid>
              </Grid>
            </Box>

           {/* Carpet Area, Built-up Area, UDS */}
{(selectedType?.id === 'apartment' || selectedType?.id === 'independent-house' || selectedType?.id === 'duplex') && (
  <Grid container spacing={2} sx={{ mb: 3 }}>
    <Grid item xs={12} sm="auto">
      <Box sx={{ width: '270px', maxWidth: '100%' }}>
        <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
          Carpet Area <span style={{ color: '#d32f2f' }}>*</span>
        </Typography>
        <TextField
          id="carpetArea"
          fullWidth
          size="small"
          placeholder="Enter carpet area"
          value={carpetArea}
          onChange={(e) => {
            const value = e.target.value.replace(/[^0-9]/g, '');
            setCarpetArea(value);
            setErrors(prev => ({...prev, carpetArea: validateNumber(value, "Carpet area")}));
          }}
          error={!!errors.carpetArea}
          helperText={errors.carpetArea}
          sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
          InputProps={{
            endAdornment: <Typography sx={{ fontSize: '13px', color: '#666', fontFamily: 'Outfit', ml: 1 }}>Sq.Yards</Typography>
          }}
        />
      </Box>
    </Grid>

    <Grid item xs={12} sm="auto">
      <Box sx={{ width: '270px', maxWidth: '100%' }}>
        <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
          Built-up Area <span style={{ color: '#d32f2f' }}>*</span>
        </Typography>
        <TextField
          id="builtUpArea"
          fullWidth
          size="small"
          placeholder="Enter built-up area"
          value={builtUpArea}
          onChange={(e) => {
            const value = e.target.value.replace(/[^0-9]/g, '');
            setBuiltUpArea(value);
            setErrors(prev => ({...prev, builtUpArea: validateNumber(value, "Built-up area")}));
          }}
          error={!!errors.builtUpArea}
          helperText={errors.builtUpArea}
          sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
          InputProps={{
            endAdornment: <Typography sx={{ fontSize: '13px', color: '#666', fontFamily: 'Outfit', ml: 1 }}>Sq.Yards</Typography>
          }}
        />
      </Box>
    </Grid>

    <Grid item xs={12} sm="auto">
   <Box sx={{ width: '270px', maxWidth: '100%' }}>
  <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
    UDS {selectedType?.id === 'independent-house' ? (
      <span style={{ color: '#d32f2f' }}>*</span>
    ) : (
      <span style={{ color: '#666', fontWeight: 400 }}>(Optional)</span>
    )}
  </Typography>
  <TextField
    id="udsArea"
    fullWidth
    size="small"
    placeholder="Enter UDS"
    value={udsArea}
    onChange={(e) => {
      const value = e.target.value.replace(/[^0-9]/g, '');
      setUdsArea(value);
      setErrors(prev => ({
        ...prev,
        udsArea: validateUdsArea(value, selectedType?.id)
      }));
    }}
    error={!!errors.udsArea}
    helperText={errors.udsArea}
    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
    InputProps={{
      endAdornment: <Typography sx={{ fontSize: '13px', color: '#666', fontFamily: 'Outfit', ml: 1 }}>Sq.Yards</Typography>
    }}
  />
</Box>
    </Grid>
  </Grid>
)}
            {/* Property Size for non-apartment residential */}
            {selectedType?.id !== 'apartment' && (
              <Grid container spacing={2} sx={{ mb: 3 }}>
                <Grid item xs={12} sm={8}>
                  <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                    Property Size <span style={{ color: '#d32f2f' }}>*</span>
                  </Typography>
                  <TextField
                    id="propertySize"
                    fullWidth
                    size="small"
                    placeholder="Enter property size"
                    value={propertySize}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, '');
                      setPropertySize(value);
                      setErrors(prev => ({...prev, propertySize: validateNumber(value, "Property size")}));
                    }}
                    error={!!errors.propertySize}
                    helperText={errors.propertySize}
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                    Unit
                  </Typography>
                  <FormControl fullWidth size="small">
                    <Select
                      value={selectedUnit}
                      onChange={(e) => setSelectedUnit(e.target.value)}
                      sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}>
                      <MenuItem value="sq.ft">Sq. ft</MenuItem>
                      <MenuItem value="sqm">Sq. m</MenuItem>
                      <MenuItem value="acres">Acres</MenuItem>
                      <MenuItem value="sq.yards">Sq. yards</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            )}
          </>
        )}

        {/* Commercial Fields (NOT Plot) */}
        {isCommercial && !isPlot && (
          <>
            {/* Property Size - Full Width */}
            <Grid container spacing={2} sx={{ mb: 3 }}>
              <Grid item xs={12} sm={8}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  Property Size <span style={{ color: '#d32f2f' }}>*</span>
                </Typography>
                <TextField
                  id="propertySize"
                  fullWidth
                  size="small"
                  placeholder="Enter property size"
                  value={propertySize}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^0-9]/g, '');
                    setPropertySize(value);
                    setErrors(prev => ({...prev, propertySize: validateNumber(value, "Property size")}));
                  }}
                  error={!!errors.propertySize}
                  helperText={errors.propertySize}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  Unit
                </Typography>
                <FormControl fullWidth size="small">
                  <Select
                    value={selectedUnit}
                    onChange={(e) => setSelectedUnit(e.target.value)}
                    sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}>
                    <MenuItem value="sq.ft">Sq. ft</MenuItem>
                    <MenuItem value="sqm">Sq. m</MenuItem>
                    <MenuItem value="acres">Acres</MenuItem>
                    <MenuItem value="sq.yards">Sq. yards</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>

            {/* Available Floors Section */}
            <Box sx={{ mb: 3 }}>
              <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#333', fontFamily: 'Outfit', mb: 2 }}>
                Available Floors <span style={{ color: '#d32f2f' }}>*</span>
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm="auto">
                  <Box sx={{ width: '185px', maxWidth: '100%' }}>
                    <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                      Total Floors
                    </Typography>
                    <TextField
                      id="totalFloors"
                      fullWidth
                      size="small"
                      placeholder="Enter total floors"
                      value={totalFloors}
                      onChange={(e) => {
                        const value = e.target.value.replace(/[^0-9]/g, '');
                        setTotalFloors(value);
                        setErrors(prev => ({...prev, totalFloors: validateNumber(value, "Total floors", 1, 100)}));
                      }}
                      error={!!errors.totalFloors}
                      helperText={errors.totalFloors}
                      sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                    />
                  </Box>
                </Grid>

                <Grid item xs={12} sm="auto">
                  <Box sx={{ width: '185px', maxWidth: '100%' }}>
                    <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                      Select Floor
                    </Typography>
                    <FormControl fullWidth size="small" error={!!errors.selectedFloor}>
                      <Select
                        id="selectedFloor"
                        value={selectedFloor}
                        onChange={(e) => {
                          setSelectedFloor(e.target.value);
                          setErrors({...errors, selectedFloor: ''});
                        }}
                        displayEmpty
                        sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                      >
                        <MenuItem value="" disabled>Select Floor</MenuItem>
                        {[...Array(20)].map((_, i) => (
                          <MenuItem key={i + 1} value={`${i + 1}${i === 0 ? 'st' : i === 1 ? 'nd' : i === 2 ? 'rd' : 'th'} Floor`}>
                            {i + 1}{i === 0 ? 'st' : i === 1 ? 'nd' : i === 2 ? 'rd' : 'th'} Floor
                          </MenuItem>
                        ))}
                      </Select>
                      {errors.selectedFloor && <FormHelperText sx={{ fontSize: '11px' }}>{errors.selectedFloor}</FormHelperText>}
                    </FormControl>
                  </Box>
                </Grid>

                <Grid item xs={12} sm="auto">
                  <Box sx={{ width: '200px', maxWidth: '100%' }}>
                    <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                      Ownership
                    </Typography>
                    <FormControl fullWidth size="small">
                      <Select
                        value={selectedOwnership}
                        onChange={(e) => setSelectedOwnership(e.target.value)}
                        displayEmpty
                        sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}>
                        <MenuItem value="" disabled><em>Select Ownership</em></MenuItem>
                        {ownerships.map((own) => (
                          <MenuItem key={own} value={own}>{own}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                </Grid>

                <Grid item xs={12} sm="auto">
                  <Box sx={{ width: '200px', maxWidth: '100%' }}>
                    <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                      Hub
                    </Typography>
                    <FormControl fullWidth size="small">
                      <Select
                        value={selectedHub}
                        onChange={(e) => setSelectedHub(e.target.value)}
                        displayEmpty
                        sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}>
                        <MenuItem value="" disabled><em>Select Hub</em></MenuItem>
                        {hubs.map((hub) => (
                          <MenuItem key={hub} value={hub}>{hub}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </>
        )}
      </Box>
    );
  };

  return (
    <PostAccess 
      currentStep={1} 
      category={category} 
      propertyType={propertyType} 
      assetType={selectedPropertyType}
    >
      <Paper
        elevation={0}
        sx={{
          flex: 1,
          maxWidth: { xs: '100%', md: '900px' },
          p: { xs: 2.5, sm: 3, md: 3.5 },
          backgroundColor: '#ffffff',
          borderRadius: 2,
          border: '1px solid #e0e0e0',
        }}
      >
        <Typography
          variant="h5"
          sx={{
            fontFamily: 'Outfit',
            fontWeight: 600,
            mb: 0.5,
            fontSize: { xs: '18px', md: '22px' },
          }}
        >
          Add Property Details
        </Typography>
        <Typography
          sx={{
            fontFamily: 'Outfit',
            fontSize: '13px',
            color: '#666',
            mb: 3,
          }}
        >
          {progress}% <span style={{ color: progress > 75 ? '#4caf50' : progress > 50 ? '#ff9800' : '#2196f3' }}>●●●○○</span>
        </Typography>

        {renderForm()}

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            gap: 2,
            mt: 4,
          }}
        >
          <Button
            variant="outlined"
            onClick={handleBack}
            sx={{
              px: 3,
              py: 1,
              borderRadius: 1.5,
              textTransform: 'none',
              fontFamily: 'Outfit',
              fontSize: '13px',
              color: '#666',
              borderColor: '#e0e0e0',
              minWidth: { xs: '80px', sm: '100px' },
            }}
          >
            Back
          </Button>
          <Button
            variant="contained"
            onClick={handleNext}
            sx={{
              px: 3,
              py: 1,
              borderRadius: 1.5,
              textTransform: 'none',
              fontFamily: 'Outfit',
              fontSize: '13px',
              backgroundColor: '#1976d2',
              minWidth: { xs: '80px', sm: '100px' },
              '&:hover': {
                backgroundColor: '#1565c0',
              },
            }}
          >
            Next
          </Button>
        </Box>
      </Paper>

      {/* Image Preview Dialog */}
      {imagePreviews.length > 0 && (
        <Dialog
          open={previewOpen}
          onClose={() => setPreviewOpen(false)}
          maxWidth="md"
          fullWidth
          sx={{ '& .MuiDialog-paper': { borderRadius: '12px', overflow: 'hidden', bgcolor: 'black' } }}
        >
          <DialogContent sx={{ p: 0, position: 'relative' }}>
            <Box
              component="img"
              src={imagePreviews[selectedImageIndex]}
              alt={`Image ${selectedImageIndex + 1}`}
              sx={{ width: '100%', height: 'auto', maxHeight: '80vh', objectFit: 'contain' }}
            />
            <IconButton
              onClick={() => setPreviewOpen(false)}
              sx={{
                position: 'absolute',
                top: 8,
                right: 8,
                bgcolor: 'rgba(255, 255, 255, 0.3)',
                color: 'white',
                '&:hover': { bgcolor: 'rgba(255, 255, 255, 0.5)' }
              }}
            >
              <CloseIcon />
            </IconButton>
            {imagePreviews.length > 1 && (
              <>
                <IconButton
                  onClick={() => setSelectedImageIndex(prev => (prev > 0 ? prev - 1 : imagePreviews.length - 1))}
                  sx={{
                    position: 'absolute',
                    left: 8,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    bgcolor: 'rgba(255, 255, 255, 0.3)',
                    color: 'white',
                    '&:hover': { bgcolor: 'rgba(255, 255, 255, 0.5)' }
                  }}
                >
                  ‹
                </IconButton>
                <IconButton
                  onClick={() => setSelectedImageIndex(prev => (prev < imagePreviews.length - 1 ? prev + 1 : 0))}
                  sx={{
                    position: 'absolute',
                    right: 8,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    bgcolor: 'rgba(255, 255, 255, 0.3)',
                    color: 'white',
                    '&:hover': { bgcolor: 'rgba(255, 255, 255, 0.5)' }
                  }}
                >
                  ›
                </IconButton>
                <Box
                  sx={{
                    position: 'absolute',
                    bottom: 16,
                    left: '50%',
                    transform: 'translateX(-50%)',
                    bgcolor: 'rgba(0, 0, 0, 0.7)',
                    color: 'white',
                    px: 2,
                    py: 1,
                    borderRadius: '16px',
                    fontSize: '14px',
                    fontFamily: 'Outfit'
                  }}
                >
                  {selectedImageIndex + 1} / {imagePreviews.length}
                </Box>
              </>
            )}
          </DialogContent>
        </Dialog>
      )}
    </PostAccess>
  );
};

export default PropertyDetails;